// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "admin" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "layout.dashboard": "Tableau de bord",
      "layout.viewSite": "Voir le site",
      "layout.viewMarketplace": "Voir la place de marché",
      "overview.hello": "Bonjour",
      "overview.subtitle": "Voici un aperçu de votre site.",
      "overview.siteOnline": "Votre site est en ligne",
      "overview.siteOnlineSub": "Modifiez vos couleurs, contenus et modèle quand vous voulez.",
      "overview.editSite": "Modifier mon site",
      "overview.notPublished": "Site non publié",
      "overview.start5min": "5 min pour démarrer",
      "overview.startSub": "Choisissez un modèle, personnalisez vos couleurs et publiez votre site en ligne.",
      "overview.published": "publiés",
      "overview.active": "actifs",
      "overview.unread": "non lus",
      "overview.pending": "en attente",
      "overview.filesUploaded": "fichiers uploadés",
      "actions.save": "Enregistrer",
      "actions.saved": "Enregistré",
      "actions.add": "Ajouter",
      "settings.title": "Paramètres du site",
      "settings.subtitle": "Réglages globaux.",
      "settings.calendly": "Calendly URL (optionnel)",
      "settings.practiceName.title": "Nom de la pratique",
      "settings.practiceName.subtitle": "Le nom que vos clients voient partout : votre site, la place de marché, vos courriels et le relevé de leur carte.",
      "settings.practiceName.label": "Nom de la pratique",
      "settings.practiceName.hint": "Les reçus déjà émis gardent le nom qu'ils portaient. Si vous avez rempli un profil fiscal, vos reçus utilisent la raison sociale qui s'y trouve.",
      "settings.practiceName.save": "Enregistrer le nom",
      "settings.practiceName.saved": "Nom enregistré",
      "settings.practiceName.tooShort": "Le nom de la pratique doit contenir au moins 2 caractères.",
      "settings.practiceName.tooLong": "Le nom de la pratique ne peut pas dépasser 120 caractères.",
      "settings.email": "Courriel professionnel",
      "settings.phone": "Téléphone (optionnel)",
      "settings.shopEnabled": "Boutique active (visible publiquement)",
      "settings.yes": "Oui",
      "settings.no": "Non",
      "settings.bookingTermsFr": "Conditions de réservation (FR)",
      "settings.bookingTermsEn": "Conditions de réservation (EN)",
      "avail.error": "Erreur",
      "bookings.title": "Rendez-vous",
      "bookings.subtitle": "Les réservations effectuées par vos clientes.",
      "bookings.all": "Toutes",
      "bookings.pending": "En attente",
      "bookings.confirmed": "Confirmées",
      "bookings.cancelled": "Annulées",
      "bookings.empty": "Aucun rendez-vous dans cette catégorie.",
      "bookings.slot": "Créneau",
      "bookings.client": "Client",
      "bookings.roomCreated": "Room créée — URL copiée et envoyée",
      "bookings.statusUpdated": "Statut mis à jour",
      "bookings.timeTaken": "Son horaire a été réservé par quelqu'un d'autre entre-temps : ce rendez-vous ne peut pas être rétabli.",
      "bookings.statusError": "Erreur lors de la mise à jour du statut",
      "bookings.startVideo": "Démarrer la consultation vidéo",
      "bookings.confirm": "Confirmer",
      "bookings.cancel": "Annuler",
      "bookings.statusLabel.pending": "En attente",
      "bookings.statusLabel.confirmed": "Confirmé",
      "bookings.statusLabel.cancelled": "Annulé",
      "bookings.statusLabel.pending_payment": "Paiement en attente",
      "bookings.statusLabel.paid_needs_attention": "Payé — à traiter",
      // F-25 — the seat of a per-minute consultation once its money is settled.
      // Machine-written (gateway/handoff.complete_consult_booking); the status
      // control cannot set it, so it only ever appears as a label.
      "bookings.statusLabel.completed": "Terminé",
      "bookings.pendingPayment": "Paiement en attente",
      "bookings.paidNeedsAttention": "Payé — à traiter",
      "bookings.awaitingPayment": "En attente de paiement",
      "bookings.expiresIn": "expire dans {min} min",
      "bookings.expired": "expiré",
      "bookings.paidWarnTitle": "Annuler ce rendez-vous payé ?",
      "bookings.paidWarnBody": "La cliente a payé {amount}. Annuler NE la rembourse PAS — le remboursement reste une action séparée, disponible juste après.",
      "bookings.paidWarnDismiss": "Retour",
      "bookings.paidWarnConfirm": "Annuler quand même",
      "bookings.refundFollowupTitle": "Rendez-vous annulé",
      "bookings.refundFollowupBody": "Voulez-vous rembourser les {amount} encaissés maintenant ?",
      "bookings.refundLater": "Plus tard",
      "bookings.refundNow": "Rembourser maintenant",
      "bookings.refundSuccess": "Remboursement effectué",
      "bookings.refundError": "Échec du remboursement",
      "bookings.needsAttentionTitle": "Payé, mais plus de place disponible",
      "bookings.needsAttentionBody": "Le paiement est arrivé après l'expiration du maintien de place, et son horaire a été réservé par quelqu'un d'autre entre-temps. L'argent est encaissé : conservez le rendez-vous (possible seulement si son horaire est de nouveau libre) ou remboursez et annulez.",
      "bookings.keepAppointment": "Conserver le rendez-vous",
      "bookings.refundAndCancel": "Rembourser et annuler",
      "cal.title": "Calendrier",
      "cal.subtitle": "Vos rendez-vous sur fond de vos heures d'ouverture. Faites glisser un rendez-vous pour le déplacer.",
      "cal.today": "Aujourd'hui",
      "cal.month": "Mois",
      "cal.week": "Semaine",
      "cal.day": "Jour",
      "cal.apptRescheduled": "Rendez-vous déplacé au {time}",
      "cal.loadError": "Erreur de chargement",
      "gcal.title": "Google Calendar",
      "gcal.desc": "Synchronisez vos rendez-vous dans les deux sens avec votre Google Calendar.",
      "gcal.connect": "Connecter Google Calendar",
      "gcal.connected": "Connecté",
      "gcal.connectedAs": "Connecté en tant que",
      "gcal.disconnect": "Déconnecter",
      "gcal.syncNow": "Synchroniser maintenant",
      "gcal.syncing": "Synchronisation…",
      "gcal.lastSync": "Dernière sync",
      "gcal.never": "Jamais",
      "gcal.syncDone": "Synchronisé : {pushed} rendez-vous poussés, {busy} événements importés",
      "gcal.syncPartial": "Sync incomplète : {pushed} poussés, {failed} échecs — votre agenda Google peut être incomplet",
      "cal.detailDialogDesc": "Détails du rendez-vous",
      "ovr.dialogDesc": "Ajouter une période de fermeture",
      "gcal.connectedToast": "Google Calendar connecté avec succès",
      "gcal.errorToast": "Échec de la connexion à Google Calendar",
      "gcal.scopeMissing": "Connexion refusée : la permission « Agenda » n'a pas été accordée. Reconnectez-vous et cochez l'accès à Google Agenda.",
      "gcal.disconnected": "Google Calendar déconnecté",
      "gcal.notConfigured": "Google Calendar n'est pas configuré sur la plateforme.",
      "gcal.busyLegend": "Événements Google (occupé)",
      "cal.updated": "Mis à jour",
      "cal.video": "Vidéo",
      "cal.confirmDetachCancel": "Annuler",
      "cal.confirmOverrideTitle": "Déplacer malgré tout ?",
      "cal.confirmOverrideOutsideBody": "Cette heure est en dehors de vos disponibilités publiées (horaire hebdomadaire, heures supplémentaires ou fermeture). Vous pouvez déplacer le rendez-vous quand même : il aura lieu en dehors de vos heures publiées.",
      "cal.confirmOverrideBusyBody": "Un événement Google externe occupe déjà cette plage horaire. Vous pouvez déplacer le rendez-vous quand même : vous aurez deux engagements au même moment.",
      "cal.confirmOverrideCancel": "Annuler",
      "cal.confirmOverrideConfirm": "Déplacer quand même",
      "err.gcalNotConnected": "Google Calendar n'est pas connecté",
      "err.invalidWindows": "Certaines plages horaires sont invalides ou se chevauchent",
      "err.invalidTimezone": "Fuseau horaire invalide",
      "err.invalidRange": "Plage de dates invalide",
      "err.templateNotFound": "Aucun horaire hebdomadaire trouvé pour l'instant",
      "err.tenantSuspended": "Compte suspendu : consultation possible, modifications bloquées. Régularisez la facturation pour réactiver.",
      "err.outsideAvailability": "Cette heure est en dehors de vos disponibilités publiées.",
      "err.targetGcalBusy": "Un événement Google externe occupe déjà cette plage horaire.",
      "err.paymentPending": "Ce rendez-vous attend un paiement — cette action est bloquée tant que le paiement n'est pas réglé (annuler ou attendre reste possible).",
      "err.consultCharged": "Cette consultation a déjà été facturée : elle ne peut plus être annulée. Pour rendre l'argent, passez par un remboursement depuis les Paiements.",
      "gate.title": "Connectez Google Calendar pour publier",
      "gate.body": "Publier votre horaire hebdomadaire nécessite un Google Calendar connecté, afin que les horaires proposés tiennent compte de votre agenda et évitent les doubles réservations.",
      "gcal.disconnectWarnTitle": "Déconnecter Google Calendar ?",
      "gcal.disconnectWarnBody": "{n} rendez-vous à venir sont synchronisés avec Google Calendar. La déconnexion arrêtera leur synchronisation — ils resteront dans Solunary mais ne seront plus reflétés dans Google.",
      "gcal.disconnectWarnBodyNone": "Aucun rendez-vous à venir synchronisé. Vous pouvez déconnecter Google Calendar en toute sécurité.",
      "sync.busyChecked": "Occupations Google vérifiées {time}",
      "sync.busyCheckedNever": "Pas encore vérifié",
      "sync.mismatchPill": "{n} réservations à vérifier",
      "sync.mismatchHelp": "Ces rendez-vous ne correspondent plus à votre Google Calendar : l'événement a été déplacé ou supprimé côté Google. Ouvrez le calendrier pour les revoir.",
      "sync.checkNow": "Vérifier maintenant",
      "sync.checking": "Vérification…",
      "sync.reconcileToast": "{cancelled} annulé(s) · {drifted} déplacé(s)",
      "sync.noneLeft": "Plus aucune réservation à vérifier",
      "sync.driftBanner": "Ce rendez-vous a été déplacé dans Google Calendar.",
      "sync.driftGoogleTime": "Google Calendar : {time}",
      "sync.driftSolunaryTime": "Solunary : {time}",
      "sync.repush": "Repousser vers Google",
      "sync.repushDone": "Repoussé vers Google Calendar",
      "sync.acknowledge": "Acquitter",
      "sync.ackDone": "Confirmé",
      "sync.googleCancelledBanner": "Ce rendez-vous a été annulé depuis Google Calendar. La cliente n'a pas été avisée.",
      "ovr.title": "Dates bloquées",
      "ovr.subtitle": "Les jours où vous êtes indisponible, même pendant vos heures habituelles.",
      "ovr.add": "Bloquer une date",
      "ovr.empty": "Aucune date bloquée pour l'instant.",
      "ovr.dateFrom": "Du",
      "ovr.dateFromRequired": "La date de début est requise",
      "ovr.dateTo": "Au (optionnel)",
      "ovr.dateToHint": "Laissez vide pour bloquer un seul jour",
      "ovr.reason": "Raison (optionnel)",
      "ovr.reasonPlaceholder": "ex. Vacances, jour de congé…",
      "ovr.create": "Bloquer les dates",
      "ovr.created": "Dates bloquées",
      "ovr.confirmDelete": "Retirer cette date bloquée ?",
      "ovr.deleted": "Date bloquée retirée",
      "ovr.conflicts": "{count} réservation(s) existante(s) se trouvent dans cette plage",
      "ovr.dialogTitle": "Bloquer des dates",
      "sched.pageTitle": "Réglages de disponibilité",
      "sched.pageSubtitle": "Définissez vos heures d'ouverture et les services proposés : vos clients choisissent un service, puis un horaire.",
      "sched.viewCalendarLink": "Voir le calendrier",
      "sched.settingsTitle": "Horaire hebdomadaire",
      "sched.timezone": "Fuseau horaire",
      "sched.statusDraft": "Brouillon",
      "sched.statusPublished": "Publié",
      "sched.save": "Enregistrer",
      "sched.saved": "Horaire enregistré",
      "sched.publish": "Publier",
      "sched.published": "Horaire publié",
      "sched.publishNeedsConnect": "Connectez Google Calendar pour publier votre horaire",
      "sched.publishNeedsSave": "Enregistrez vos modifications avant de publier",
      "sched.dirty": "Modifications non enregistrées",
      "sched.loadError": "Impossible de charger votre horaire",
      "sched.windowOverlap": "Des plages horaires se chevauchent",
      "sched.windowInvalid": "L'heure de fin doit être après l'heure de début",
      "sched.addWindow": "Ajouter une plage",
      "sched.dayClosed": "Fermé",
      "msg.title": "Messages",
      "msg.subtitle": "Vos conversations avec vos clients.",
      "msg.empty": "Aucune conversation pour le moment.",
      "msg.selectToRead": "Sélectionnez une conversation pour la lire.",
      "msg.noMessagesYet": "Aucun message dans cette conversation.",
      "msg.loadOlder": "Afficher les messages plus anciens",
      "msg.reply": "Votre réponse",
      "msg.replyPlaceholder": "Écrivez votre réponse…",
      "msg.send": "Envoyer",
      "msg.sending": "Envoi…",
      "msg.you": "Vous",
      "msg.client": "Client",
      "msg.charCount": "{n}/{max}",
      "msg.unread": "Non lu",
      "msg.unreadOne": "1 message non lu",
      "msg.unreadMany": "{n} messages non lus",
      "testi.title": "Témoignages",
      "testi.subtitle": "Ajoutez les avis clients qui apparaissent sur le site.",
      "testi.new": "Nouveau",
      "testi.empty": "Aucun témoignage personnalisé pour l'instant. Les témoignages par défaut continuent d'apparaître sur le site.",
      "testi.active": "Actif",
      "testi.hidden": "Caché",
      "testi.order": "Ordre",
      "testi.confirmDelete": "Supprimer le témoignage de {name} ?",
      "testi.newTitle": "Nouveau témoignage",
      "testi.editTitle": "Modifier",
      "testi.field.name": "Nom",
      "testi.field.link": "Lien (Google Maps)",
      "testi.field.quoteFr": "Citation (FR)",
      "testi.field.quoteEn": "Citation (EN)",
      "testi.field.charCount": "{count} / {max} caractères",
      "testi.field.status": "Statut",
      "blog.title": "Articles du journal",
      "blog.subtitle": "Créez, modifiez et publiez vos articles.",
      "blog.new": "Nouvel article",
      "blog.empty": "Aucun article pour le moment.",
      "blog.published": "Publié",
      "blog.draft": "Brouillon",
      "blog.untitled": "Sans titre",
      "blog.confirmDelete": "Supprimer « {title} » ?",
      "blog.saveError": "Erreur lors de la sauvegarde",
      "blog.editTitle": "Modifier",
      "blog.newTitle": "Nouvel article",
      "blog.field.titleFr": "Titre (FR)",
      "blog.field.tagFr": "Tag (FR)",
      "blog.field.excerptFr": "Extrait (FR)",
      "blog.field.bodyFr": "Contenu (FR)",
      "blog.field.titleEn": "Title (EN)",
      "blog.field.tagEn": "Tag (EN)",
      "blog.field.excerptEn": "Excerpt (EN)",
      "blog.field.bodyEn": "Body (EN)",
      "blog.field.slug": "Slug",
      "blog.field.cover": "Image de couverture",
      "blog.field.status": "Statut",
      "blog.upload": "Téléverser",
      "branding.subtitle": "Personnalisez l'identité visuelle de votre site public.",
      "branding.saved": "Branding enregistré",
      "branding.imageUploaded": "Image téléversée",
      "branding.urlError": "URL non récupérée",
      "branding.uploadError": "Erreur upload",
      "branding.identity": "Identité",
      "branding.tagline": "Tagline (sous le titre principal)",
      "branding.taglinePlaceholder": "Un voyage vers le bien-être naturel",
      "branding.specialties": "Spécialités (visibles dans la marketplace Solunary)",
      "content.title": "Contenu du site",
      "content.subtitle": "Modifiez le texte de votre page d'accueil, section par section, dans l'ordre où vos visiteurs le lisent. Un champ laissé vide affiche le texte d'exemple, sauf si sa note dit autre chose.",
      "content.confirmDelete": "Supprimer la personnalisation « {key} » ?",
      "content.addCustom": "Ajouter une clé personnalisée",
      "content.addCustomHint": "Optionnel · Réservé aux réglages avancés si vous devez surcharger une clé spécifique de votre modèle.",
      "content.create": "Créer",
      "content.customPrefix": "Personnalisé",
      "content.frPlaceholder": "Texte FR (vide = par défaut)",
      "content.enPlaceholder": "Texte EN (vide = par défaut)",
      "content.preset.hero.eyebrow": "Hero · Badge au-dessus du titre",
      "content.preset.hero.script": "Hero · Phrase manuscrite",
      "content.preset.hero.sub": "Hero · Sous-titre",
      "content.preset.story.eyebrow": "Mon parcours · Petit titre au-dessus",
      "content.preset.story.title": "Mon parcours · Titre",
      "content.preset.story.lead": "Mon parcours · Intro",
      "content.preset.approach.eyebrow": "Approche · Petit titre au-dessus",
      "content.preset.approach.title": "Approche · Titre",
      "content.preset.approach.lead": "Approche · Intro",
      "content.preset.services.lead": "Services · Intro",
      "content.preset.contact.lead": "Contact · Intro",
      "content.preset.contact.email": "Contact · Email",
      "content.preset.contact.place": "Contact · Lieu",
      "content.section.hero": "Section Hero",
      "content.section.story": "Section Mon parcours",
      "content.section.approach": "Section Approche",
      "content.section.services": "Section Services",
      "content.section.contact": "Section Contact",
      "nav.overview": "Vue d'ensemble",
      "nav.blog": "Articles",
      "nav.testimonials": "Témoignages",
      "nav.messages": "Messages",
      "nav.availability": "Disponibilités",
      "nav.bookings": "Rendez-vous",
      "nav.calendar": "Calendrier",
      "nav.customers": "Mes Clients",
      "nav.quizReviews": "Revue de quiz",
      "nav.learnAnalytics": "Analytics Learn",
      "nav.payments": "Paiements",
      "nav.taxConfig": "Taxes",
      "learn.title": "Solunary Learn",
      "learn.newCourse": "Nouveau cours",
      "learn.editCourse": "Modifier cours",
      "learn.addLesson": "Leçon",
      "learn.addQuiz": "Quiz",
      "learn.published": "Publié",
      "learn.publishBtn": "Publier",
      "learn.unpublishBtn": "Dépublier",
      "learn.draft": "Brouillon",
      "learn.price": "Prix",
      "learn.currency": "Devise",
      "learn.free": "Gratuit",
      "learn.mandatory": "Obligatoire",
      "learn.lesson": "Leçon",
      "learn.quiz": "Quiz",
      "learn.markComplete": "Marquer comme complétée",
      "learn.completed": "Leçon complétée",
      "learn.locked": "Leçon verrouillée",
      "learn.lockedDesc": "Complétez la leçon obligatoire précédente pour débloquer celle-ci.",
      "learn.quizSubmit": "Soumettre le quiz",
      "learn.quizRetry": "Recommencer le quiz",
      "learn.quizPassed": "Bravo, quiz réussi !",
      "learn.quizFailed": "Score insuffisant",
      "learn.answerAll": "Répondez à toutes les questions pour soumettre.",
      "learn.openAnswerHint": "Réponse libre — sera relue par le praticien",
      "learn.openAnswerPlaceholder": "Votre réponse…",
      "learn.enrollPrice": "Acheter et accéder",
      "learn.enrollFree": "Commencer le cours",
      "learn.emailPlaceholder": "votre.email@example.com",
      "learn.coursesWord": "cours",
      "learn.sellHint": "Créez et vendez vos formations.",
      "learn.fieldTitle": "Titre *",
      "learn.fieldDescription": "Description",
      "learn.coverUrl": "Image de couverture (URL)",
      "learn.freeHint": "0 = gratuit",
      "learn.pricePlaceholder": "0.00 = gratuit",
      "learn.publishLabel": "Publier le cours (visible publiquement et dans la marketplace Solunary)",
      "learn.lessonsWord": "Leçons",
      "learn.noLessons": "Aucune leçon. Ajoutez une Leçon (contenu vidéo/texte) ou un Quiz.",
      "learn.publishNeedsLesson": "Ajoutez au moins une leçon pour publier ce cours.",
      "learn.lastLessonPublished": "Un cours publié doit garder au moins une leçon : dépubliez-le d’abord.",
      "learn.publishedEmptyWarning": "Publié sans leçon : personne ne peut l’acheter. Ajoutez une leçon ou dépubliez-le.",
      "learn.publishedToast": "Cours publié.",
      "learn.unpublishedToast": "Cours dépublié.",
      "learn.coursesEmpty": "Votre travail en 1:1 est déjà du matériel de cours. Laissez Solunary AI transformer vos protocoles en votre première cohorte.",
      "learn.editBtn": "Éditer",
      "learn.titlePlaceholderQuiz": "Titre du quiz",
      "learn.titlePlaceholderLesson": "Titre de la leçon",
      "learn.mandatoryDescQuiz": "Obligatoire — verrouille les leçons suivantes tant qu'elle n'est pas réussie",
      "learn.mandatoryDescLesson": "Obligatoire — verrouille les leçons suivantes tant qu'elle n'est pas complétée",
      "learn.videoPlaceholder": "URL vidéo (YouTube embed, Vimeo, MP4 hébergé)",
      "learn.lessonBodyPlaceholder": "Texte de la leçon (optionnel)",
      "learn.passThreshold": "Seuil de réussite",
      "learn.durationLabel": "Durée",
      "learn.minutesSuffix": "min",
      "learn.qOpen": "ouverte",
      "learn.qMcq": "QCM",
      "learn.questionPlaceholder": "Question…",
      "learn.openAnswerDesc": "L'étudiant répondra par un texte libre. Auto-créditée à la soumission, vous pouvez relire les réponses dans la fiche client.",
      "learn.markCorrect": "Marquer comme bonne réponse",
      "learn.choiceWord": "Choix",
      "learn.addChoice": "+ Ajouter un choix",
      "learn.mcq": "QCM",
      "learn.longAnswer": "Réponse longue",
      "learn.addQuestionHint": "Ajoutez au moins une question pour ce quiz.",
      "learn.titleRequired": "Titre requis",
      "learn.quizTitleRequired": "Donnez un titre à ce quiz avant d’enregistrer.",
      "learn.saved": "Cours enregistré",
      "learn.confirmDelete": "Supprimer ce cours ?",
      "learn.error": "Erreur",
      "promos.title": "Codes promo",
      "promos.subtitle": "Créez des codes en pourcentage ou en montant fixe.",
      "promos.code": "Code",
      "promos.type": "Type",
      "promos.percentage": "Pourcentage (%)",
      "promos.fixed": "Montant fixe ($)",
      "promos.maxUses": "Max utilisations (0 = illimité)",
      "promos.create": "Créer",
      "promos.empty": "Aucun code promo pour le moment.",
      "promos.confirmDelete": "Supprimer ?",
      "promos.discountPct": "{value}% de remise",
      "promos.discountFixed": "{value} $ de remise",
      "promos.uses": "utilisations",
      "promos.active": "actif",
      "promos.inactive": "inactif",
      "gift.title": "Cartes-cadeaux",
      "gift.subtitle": "Émettez des cartes manuellement, ou voyez celles vendues en ligne.",
      "gift.issueCard": "Émettre une carte",
      "gift.value": "Valeur (cents, ex 5000 = 50$)",
      "gift.recipientEmail": "Courriel destinataire",
      "gift.recipientName": "Nom destinataire",
      "gift.message": "Message",
      "gift.issue": "Émettre",
      "gift.empty": "Aucune carte-cadeau encore.",
      "gift.balance": "Solde",
      "gift.soldOnline": "Vendue en ligne",
      "gift.issuedManually": "Émise manuellement",
      "gift.confirmCancel": "Annuler cette carte ?",
      "gift.valueTooSmall": "Entrez une valeur d'au moins {min} {currency}.",
      "shop.title": "Boutique",
      "shop.subtitle": "Produits Stripe et liens affiliés.",
      "shop.activePublic": "Boutique active publiquement",
      "shop.new": "Nouveau",
      "shop.empty": "Aucun produit pour le moment.",
      "shop.active": "Actif",
      "shop.inactive": "Inactif",
      "shop.affiliate": "Affilié",
      "shop.externalLink": "Lien externe",
      "shop.confirmDelete": "Supprimer ?",
      "shop.newProduct": "Nouveau produit",
      "shop.edit": "Modifier",
      "shop.nameFr": "Nom (FR)",
      "shop.nameEn": "Name (EN)",
      "shop.descFr": "Description (FR)",
      "shop.descEn": "Description (EN)",
      "shop.type": "Type",
      "shop.typeStripe": "Stripe (vente directe)",
      "shop.typeAffiliate": "Lien affilié (ex: Amazon)",
      "shop.productType": "Nature du produit",
      "shop.productTypePhysical": "Physique (expédié)",
      "shop.productTypeDigital": "Numérique (téléchargement ou accès)",
      "shop.price": "Prix ($)",
      "shop.affiliateUrl": "URL d'affiliation",
      "shop.image": "Image",
      "shop.upload": "Téléverser",
      "shop.order": "Ordre",
      "shop.cancel": "Annuler",
      "shop.save": "Enregistrer",
      "tele.title": "Téléconsultation",
      "tele.subtitle": "Vos consultations vidéo : votre salle et toutes les consultations que vous avez menées.",
      "tele.empty": "Aucune consultation pour l'instant — elles apparaîtront ici dès qu'un client réservera.",
      "tele.videoProvider": "Fournisseur de visioconférence",
      "tele.videoProviderNote": "Toutes vos salles de consultation sont ouvertes chez ce fournisseur. Solunary s'en occupe : vous n'avez rien à configurer.",
      "mod.title": "Modalités de soin",
      "mod.subtitle": "Choisissez votre modalité : formulaires d'admission, taxonomie et protocoles adaptés. La modalité active contraint l'assistant IA Solunary à son périmètre.",
      "mod.error": "Erreur",
      "mod.added": "Modalité ajoutée",
      "mod.activated": "Modalité activée — l'IA est désormais contrainte à ce périmètre",
      "mod.confirmRemove": "Retirer cette modalité ?",
      "mod.myModalities": "Mes modalités",
      "mod.active": "Active",
      "mod.activate": "Activer",
      "mod.intake": "Admission ({count} champs)",
      "mod.protocols": "Protocoles",
      "mod.steps": "étapes",
      "mod.catalog": "Catalogue des modalités",
      "mod.add": "Ajouter",
      "mod.allAdded": "Toutes les modalités sont ajoutées.",
      "ai.title": "Assistant IA",
      "ai.subtitle": "Propulsé par Claude Sonnet 4.5. Rédige, résume, brainstorme — en quelques secondes.",
      "ai.task.write_article": "Rédiger un article",
      "ai.task.draft_reply": "Rédiger une réponse",
      "ai.task.summarize_messages": "Résumer des messages",
      "ai.task.free_form": "Question libre",
      "ai.ph.write_article": "Sujet de l'article (ex: bienfaits du jeûne intermittent)",
      "ai.ph.draft_reply": "Colle ici le message à répondre...",
      "ai.ph.summarize_messages": "Colle plusieurs messages, je te fais un résumé actionable.",
      "ai.ph.free_form": "Ce que tu veux...",
      "ai.promptRequired": "Saisis un prompt",
      "ai.error": "Erreur IA",
      "ai.copied": "Copié !",
      "ai.yourInput": "Ton input",
      "ai.generate": "Générer",
      "ai.response": "Réponse IA",
      "ai.copy": "Copier",
      "insights.title": "Solunary Insights",
      "insights.subtitle": "Briefing IA quotidien",
      "insights.refresh": "Rafraîchir",
      "insights.generating": "Génération du briefing...",
      "insights.draft": "Brouillon IA — vérifiez avant d'agir",
      "insights.bookingsUpcoming": "RDV à venir",
      "insights.currentLeads": "Leads à relancer",
      "insights.scheduledPosts": "Posts planifiés",
      "insights.automationRuns": "Auto. (7j)",
      "insights.cachedToday": "Mis en cache aujourd'hui",
      "insights.justNow": "Généré à l'instant",
      "insights.poweredBy": "Propulsé par Claude Sonnet 4.5",
      "lan.title": "Analytics Solunary Learn",
      "lan.subtitle": "Vue d'ensemble des performances de vos cours.",
      "lan.courses": "Cours",
      "lan.published": "{count} publiés",
      "lan.students": "Étudiants",
      "lan.enrollments": "Inscriptions",
      "lan.revenue": "Revenus",
      "lan.paidCourses": "Cours payants",
      "lan.perCourse": "Performance par cours",
      "lan.empty": "Aucun cours. Créez votre premier cours dans Solunary Learn.",
      "lan.colCourse": "Cours",
      "lan.colStatus": "Statut",
      "lan.colStudents": "Étudiants",
      "lan.colCompleted": "Complétés",
      "lan.colProgress": "Progression moy.",
      "lan.colQuiz": "Score quiz moy.",
      "lan.colRevenue": "Revenus",
      "lan.statusPublished": "Publié",
      "lan.statusDraft": "Brouillon",
      "tax.loadError": "Erreur de chargement",
      "tax.presetApplied": "Préréglage appliqué — n'oubliez pas d'enregistrer",
      "tax.saved": "Configuration fiscale enregistrée ✓",
      "tax.error": "Erreur",
      "tax.title": "Configuration fiscale",
      "tax.subtitle": "Définissez les taxes appliquées à vos cours, produits et consultations. Affichées sur chaque facture.",
      "tax.lines": "Lignes de taxe",
      "tax.add": "Ajouter",
      "tax.presets": "Préréglages courants",
      "tax.empty": "Aucune taxe configurée. Vos clients paient le prix affiché sans surcharge.",
      "tax.namePh": "Nom (TPS, TVA…)",
      "tax.ratePh": "Taux %",
      "tax.regPh": "N° d'enregistrement (optionnel)",
      "tax.inclusive": "Les prix affichés sur mon site incluent déjà les taxes (TTC)",
      "tax.save": "Enregistrer",
      "tax.previewTitle": "Aperçu sur un cours à 100,00 $",
      "tax.subtotal": "Prix HT (sous-total)",
      "tax.totalCharged": "Total facturé au client",
      "tax.commission": "Commission Solunary ({pct}%)",
      "tax.net": "Net pour vous",
      "pay.error": "Erreur",
      "pay.paypalConnected": "PayPal connecté ✓",
      "pay.confirmDisconnect": "Déconnecter {name} ?",
      "pay.disconnected": "Déconnecté",
      "pay.title": "Paiements",
      "pay.subtitle": "Connectez votre compte Stripe pour recevoir vos reversements — Solunary encaisse les paiements de vos clients et vous reverse votre part.",
      "pay.paypal.desc": "Vos clients paient avec PayPal, carte ou Pay in 4. Réseau international.",
      "pay.blockedBySolunary": "Désactivé par Solunary",
      "pay.connected": "Connecté",
      "pay.merchant": "Marchand :",
      "pay.environment": "Environnement :",
      "pay.unavailableShort": "Indisponible",
      "pay.disconnect": "Déconnecter",
      "pay.docs": "Docs",
      "pay.howItWorks": "Comment ça marche :",
      "pay.howItWorksText": " Lorsqu'un client paie un cours, un produit ou une consultation, le paiement est encaissé par Solunary. Votre part (total moins la commission plateforme) vous est ensuite reversée sur votre compte Stripe connecté — le bandeau « Dû par Solunary / Déjà reversé » ci-dessous suit ces montants.",
      "dom.copied": "Copié",
      "dom.hostName": "Hôte / Nom",
      "dom.valueTarget": "Valeur / Cible",
      "dom.copyValue": "Copier la valeur",
      "dom.error": "Erreur",
      "dom.enterDomain": "Entrez un domaine",
      "dom.saved": "Domaine enregistré — configurez le DNS puis vérifiez",
      "dom.title": "Domaine personnalisé",
      "dom.subtitle": "Utilisez votre propre adresse (ex. www.moncabinet.com) pour votre site Solunary.",
      "dom.yourDomain": "Votre domaine",
      "dom.domain": "Domaine",
      "dom.save": "Enregistrer",
      "dom.dnsSteps": "Étapes de configuration DNS",
      "dom.step1": "Connectez-vous chez votre registrar (OVH, GoDaddy, Cloudflare…).",
      "dom.step2": "Ajoutez les deux enregistrements ci-dessous.",
      "dom.verify": "Vérifier",
      "dom.lastCheck": "Dernière vérif :",
      "auto.ruleSaved": "Règle enregistrée",
      "auto.error": "Erreur",
      "auto.confirmDelete": "Supprimer cette règle ?",
      "auto.deleted": "Supprimée",
      "auto.title": "Automation",
      "auto.subtitle": "{rules} règles · {runs} exécutions récentes",
      "auto.newRule": "Nouvelle règle",
      "auto.tabRules": "Règles",
      "auto.tabHistory": "Historique",
      "auto.empty": "Aucune règle. Cliquez sur « Nouvelle règle » pour automatiser vos workflows.",
      "auto.trigger": "Trigger:",
      "auto.disable": "Désactiver",
      "auto.enable": "Activer",
      "auto.edit": "Éditer",
      "auto.runsCount": "Exécutée {count} fois",
      "auto.lastRun": "dernière:",
      "auto.modalTitleEdit": "Modifier la règle",
      "auto.modalTitleNew": "Nouvelle règle",
      "auto.name": "Nom",
      "auto.triggerLabel": "Trigger (événement déclencheur)",
      "auto.actionsLabel": "Actions (exécutées dans l'ordre)",
      "auto.addAction": "Ajouter une action",
      "auto.active": "Active",
      "auto.save": "Enregistrer",
      "auto.cancel": "Annuler",
      "auto.colDate": "Date",
      "auto.colRule": "Règle",
      "auto.colTrigger": "Trigger",
      "auto.colResults": "Résultats",
      "auto.noRuns": "Aucune exécution.",
      "social.demoAccount": "Compte démo créé",
      "social.oauthError": "Erreur OAuth",
      "social.confirmDisconnect": "Déconnecter ce compte ?",
      "social.accountDisconnected": "Compte déconnecté",
      "social.publishedOn": "Publié sur {ok}/{total} compte(s){demo}",
      "social.demoSuffix": " (mode démo)",
      "social.publishError": "Erreur publication",
      "social.postSaved": "Post enregistré",
      "social.error": "Erreur",
      "social.confirmDeletePost": "Supprimer ce post ?",
      "social.topicRequired": "Indiquez un sujet",
      "social.draftGenerated": "Brouillon généré — à valider avant utilisation",
      "social.aiError": "Erreur IA",
      "social.draftApproved": "Brouillon approuvé et inséré",
      "social.describeImage": "Décrivez l'image",
      "social.imageGenerated": "Image générée",
      "social.title": "Social Media",
      "social.subtitle": "{total} posts · {scheduled} planifiés · {drafts} brouillons",
      "social.all": "Tous",
      "social.newPost": "Nouveau post",
      "social.connectedAccounts": "Comptes connectés ({count})",
      "social.demo": "(demo)",
      "social.noAccounts": "Aucun compte connecté. Cliquez sur une plateforme ci-dessus pour démarrer.",
      "social.demoParen": "(démo)",
      "social.platforms": "Plateformes",
      "social.genWithAi": "Générer avec l'IA",
      "social.topicPh": "Sujet du post (ex: bienfaits du gingembre en automne)",
      "social.genText": "Générer le texte",
      "social.noTextWithoutValidation": "Aucun texte n'atteint un client sans validation",
      "social.approveUse": "Approuver & utiliser",
      "social.reject": "Rejeter",
      "social.imageOptional": "Image (optionnel)",
      "social.imagePh": "Décris l'image (ex: tisane fumante dans un mug en céramique)",
      "social.genImage": "Générer l'image",
      "social.modalEditPost": "Modifier le post",
      "social.modalNewPost": "Nouveau post",
      "social.content": "Contenu",
      "social.status": "Statut",
      "social.scheduledDate": "Date prévue",
      "social.save": "Enregistrer",
      "social.cancel": "Annuler",
      "social.edit": "Éditer",
      "social.publish": "Publier",
      "social.emptyPosts": "Aucun post pour l'instant.",
      "bill.error": "Erreur",
      "bill.demoPortal": "Stripe en mode démo — portail non disponible. Utilisez « Changer de plan » ci-dessous.",
      "bill.stripeError": "Erreur Stripe",
      "bill.planUpdated": "Plan mis à jour",
      "bill.title": "Abonnement & facturation",
      "bill.subtitle": "Gère ton plan, ta devise et tes paiements.",
      "bill.changePlan": "Changer de plan",
      "bill.stripePortal": "Portail Stripe",
      "bill.demoTitle": "Mode démo Stripe",
      "bill.demoText": " — les changements de plan sont appliqués immédiatement sans paiement réel. Pour passer en production, configurez une vraie clé Stripe.",
      "bill.currentPlan": "Plan actuel",
      "bill.cycle.perMonth": "par mois",
      "bill.customPrice.label": "Tarif négocié",
      "bill.customPrice.chip": "Tarif négocié",
      "bill.customPrice.until": "jusqu’au {date}",
      "bill.cycle.perYear": "par an",
      "bill.customPrice.planChangeEnds": "Changer de plan met fin à votre tarif négocié de {price}. Le nouveau plan est facturé à son prix habituel.",
      "bill.customPrice.endedByPlanChange": "Plan mis à jour. Votre tarif négocié ne s’applique plus.",
      "bill.err.billingChangeInProgress": "Une modification de facturation est déjà en cours sur votre abonnement. Réessayez dans quelques minutes.",
      "bill.err.practiceDeletionPending": "Ce cabinet est en cours de suppression : aucun achat ne peut être ouvert pour lui.",
      "bill.activatedOn": "Activé le",
      "bill.currency": "Devise",
      "bill.stripeCustomer": "Stripe Customer",
      "bill.from": "Dès {price}",
      "bill.activeAddons": "Add-ons payants actifs",
      "bill.services.title": "Solunary Services",
      "bill.services.subtitle": "Des services done-for-you pour accélérer votre pratique. Exprimez votre intérêt — notre équipe vous recontacte.",
      "bill.services.thanks": "Merci ! L'équipe Solunary vous contactera.",
      "bill.services.interestSent": "Intérêt envoyé",
      "bill.services.contactUs": "Nous contacter",
      "bill.services.pulse.desc": "Audit & santé du compte mensuel, recommandations priorisées.",
      "bill.services.grow.desc": "Accompagnement growth : funnels, contenu, campagnes.",
      "bill.services.studio.desc": "Production créative : design, vidéo, cours clés en main.",
      "bill.services.concierge.desc": "Gestion opérationnelle déléguée de votre pratique.",
      "bill.services.executive.desc": "Partenariat stratégique dédié, niveau direction.",
      "bill.boosterActivated": "Booster activé !",
      "bill.purchaseConfirmed": "Achat confirmé !",
      "bill.purchaseCancelled": "Achat annulé",
      "bill.confirmCancelBooster": "Désactiver le booster « {name} » ?",
      "bill.boosterDeactivated": "Booster désactivé",
      "bill.boosters": "Boosters",
      "bill.boostersSub": "Add-ons récurrents pour étendre votre plan (facturés mensuellement).",
      "bill.deactivate": "Désactiver",
      "bill.subscribe": "S'abonner",
      "bill.active": "Actif",
      "bill.packages": "Packages & installation",
      "bill.packagesSub": "Services clé en main, paiement unique.",
      "bill.porting": "Migration de données (Porting)",
      "bill.portingSub": "Importez vos données depuis votre ancien outil.",
      "bill.startingAt": "dès ",
      "bill.owned": "Acquis",
      "bill.buy": "Acheter",
      "bill.recentTx": "Transactions récentes",
      "bill.noTx": "Aucune transaction.",
      "bill.colDate": "Date",
      "bill.colType": "Type",
      "bill.colAmount": "Montant",
      "bill.colStatus": "Statut",
      "bill.txSubscription": "abonnement",
      "bill.changePlanTitle": "Changer de plan",
      "bill.changePlanSub": "Choisis ton nouveau plan. Les changements sont prorata.",
      "bill.planActive": "Plan actif",
      "bill.upgradeTo": "Passer à ce plan",
      "bill.downgrade": "Rétrograder",
      "bill.consolidated": "Facture consolidée",
      "bill.fourStreams": "Les 4 flux Solunary · une seule facture",
      "bill.subscriptionLabel": "Abonnement — {name}",
      "bill.annualBilling": "Facturation annuelle (2 mois offerts)",
      "bill.monthlyBilling": "Facturation mensuelle",
      "bill.addons": "Add-ons",
      "bill.none": "Aucun",
      "bill.platformFees": "Frais plateforme collectés",
      "bill.platformFeesSub": "Solunary Pay / Course Pay (à titre indicatif)",
      "bill.solunaryServices": "Services Solunary",
      "bill.interestsCount": "{count} intérêt(s)",
      "bill.oneTimeRecent": "Achats ponctuels (récents)",
      "bill.recurringTotal": "Total récurrent",
      "bill.perYear": "/an",
      "bill.perMonth": "/mois",
      "login.title": "Tableau de bord",
      "login.subtitle": "Connectez-vous pour gérer votre site.",
      "login.error": "Échec de connexion. Réessayez.",
      "login.continueGoogle": "Continuer avec Google",
      "login.restricted": "Accès restreint à l'administratrice du site.",
      "coming.title": "Modules à venir",
      "coming.subtitle": "La roadmap publique. Vote pour ceux qui te paraissent les plus utiles — on priorise par usage.",
      "coming.voteToast": "Vote enregistré pour « {title} » — merci !",
      "coming.vote": "Voter pour ce module",
      "coming.alreadyVoted": "Déjà voté — merci !",
      "coming.voteError": "Le vote n'a pas pu être enregistré. Réessayez.",
      "coming.shipped": "Déjà disponible",
      "coming.ideaTitle": "Une idée de module manquant ?",
      "coming.ideaText": "Solunary est conçu avec et pour les praticiens. Si quelque chose te freine au quotidien, on veut le savoir.",
      "coming.suggest": "Proposer une idée",
      "coming.calsync.title": "Sync calendrier 2 sens",
      "coming.calsync.cat": "Calendrier",
      "coming.calsync.desc": "Synchronisation Google Agenda & Microsoft/Outlook : vos RDV et disponibilités synchronisés en temps réel.",
      "coming.social.title": "Connexions sociales",
      "coming.social.cat": "Authentification",
      "coming.social.desc": "Inscription/connexion via Google, Facebook et LinkedIn pour vous et vos clients.",
      "coming.multi.title": "Multi-praticiens avancé",
      "coming.multi.cat": "Équipe & rôles",
      "coming.multi.desc": "Rôles fins (admin, praticien, réceptionniste), permissions par module, journal d'audit.",
      "coming.workflows.title": "Workflows visuels",
      "coming.workflows.cat": "Automation Pro",
      "coming.workflows.desc": "Builder visuel multi-étapes (style n8n) avec branches conditionnelles et délais.",
      "coming.emr.title": "Intégrations EMR/EHR",
      "coming.emr.cat": "Interopérabilité santé",
      "coming.emr.desc": "HL7 FHIR, Practice Better, Jane sync, exports conformité HIPAA/PHIPA.",
      "qr.statusPending": "À relire",
      "qr.statusApproved": "Approuvé",
      "qr.statusRejected": "Rejeté",
      "qr.error": "Erreur",
      "qr.marked": "Marqué : {status}",
      "qr.title": "Relecture des quiz",
      "qr.subtitle": "{pending} à relire · {approved} approuvés · {rejected} rejetés",
      "qr.filterAll": "Toutes",
      "qr.empty": "Aucune réponse longue à relire.",
      "qr.mcqScore": "Score MCQ : {score}% · {result}",
      "qr.passed": "réussi",
      "qr.failed": "échoué",
      "qr.lesson": "Leçon :",
      "qr.student": "Étudiant :",
      "qr.approve": "Approuver",
      "qr.reject": "Rejeter",
      "qr.question": "Question",
      "qr.studentAnswer": "Réponse de l'étudiant",
      "qr.noAnswer": "Aucune réponse",
      "sconn.active": "Actif",
      "sconn.toFinalize": "À finaliser",
      "sconn.notConnected": "Non connecté",
      "sconn.desc": "Recevez les reversements de vos ventes sur votre compte Stripe. Solunary encaisse chaque vente, puis vous reverse votre part après un délai de retenue. La commission plateforme est de {fee}.",
      "sconn.descVaries": "Recevez les reversements de vos ventes sur votre compte Stripe. Solunary encaisse chaque vente, puis vous reverse votre part après un délai de retenue. La commission plateforme dépend du type de prestation :",
      "sconn.feeScopeNote": "Le solde disponible, le délai de retenue et l\u2019historique des versements sont dans votre portefeuille, plus bas sur cette page.",
      "sconn.svc.course": "Cours",
      "sconn.svc.booking": "Rendez-vous",
      "sconn.svc.product": "Produits",
      "sconn.svc.program": "Programmes",
      "sconn.svc.invoice": "Factures",
      "sconn.svc.telehealth": "Téléconsultations",
      "sconn.blocked.no_account": "Votre compte Stripe n'est pas encore connecté.",
      "sconn.blocked.payouts_disabled": "Stripe a suspendu vos virements.",
      "sconn.blocked.transfers_inactive": "Stripe n'a pas encore activé la réception de fonds sur votre compte.",
      "sconn.blocked.requirements_past_due": "Des justificatifs sont en retard : Stripe bloque vos virements jusqu'à réception.",
      "sconn.reqTitle": "Stripe attend encore :",
      "sconn.reqDisabledReason": "Motif indiqué par Stripe :",
      "sconn.req.external_account": "Vos coordonnées bancaires",
      "sconn.req.individual.verification.document": "Une pièce d'identité",
      "sconn.req.individual.id_number": "Votre numéro d'identification",
      "sconn.req.business_profile.url": "L'adresse de votre site",
      "sconn.req.business_profile.mcc": "Votre secteur d'activité",
      "sconn.account": "Compte :",
      "sconn.payments": "Paiements :",
      "sconn.payouts": "Virements :",
      "sconn.demoNote": "Mode démo — Stripe Connect n'est pas configuré sur la plateforme.",
      "sconn.blockedNote": "Ce moyen de paiement a été désactivé par l'administration Solunary.",
      "sconn.manage": "Gérer mon compte",
      "sconn.finalize": "Finaliser l'onboarding",
      "sconn.connect": "Connecter Stripe",
      "sconn.docs": "Docs",
      "sconn.returnToast": "Retour de Stripe — actualisation du statut…",
      "sconn.error": "Erreur",
      "sconn.unavailable": "Stripe Connect non disponible",
      "brand.preview": "Aperçu",
      "brand.myClinic": "Mon cabinet",
      "brand.taglineHere": "Tagline ici",
      "brand.book": "Réserver",
      "brand.viewFullSite": "Voir le site complet →",
      "brand.palette": "Palette",
      "brand.presetDefault": "Solunary (défaut)",
      "brand.colorPrimary": "Primaire (sombre)",
      "brand.colorAccent": "Accent (chaud)",
      "brand.colorSecondary": "Secondaire",
      "brand.images": "Images",
      "brand.logoLabel": "Logo (carré, ≥256×256px)",
      "brand.heroLabel": "Image hero (paysage, ≥1600×900px)",
      "brand.remove": "Retirer",
      "brand.clickUpload": "Cliquer pour téléverser",
      "brand.orPasteUrl": "ou collez une URL",
      "brand.specialtyPlaceholder": "+ Spécialité (Entrée pour valider)",
      "brand.add": "Ajouter",
      "brand.suggestions": "Suggestions",
      "brand.social": "Réseaux sociaux",
      "brand.socialHint": "Ces liens s'affichent dans le pied de page de votre site public. Laissez vide les réseaux que vous n'utilisez pas : aucune icône ne sera affichée.",
      "brand.certificateTitle": "Certificats de réussite",
      "brand.certificateSubtitle": "Personnalisez le logo et le style de conception de vos certificats de fin de parcours.",
      "brand.certificateLogoLabel": "Logo personnalisé du certificat",
      "brand.certificateLogoHint": "Laissez vide pour utiliser votre logo de marque principal.",
      "brand.certificateStyleLabel": "Style de conception",
      "brand.certificatePreviewBtn": "Aperçu du certificat (PDF)",
      "brand.certificateStyle.classic": "Sauge Solunary (Classique)",
      "brand.certificateStyle.classicDesc": "Bordure sauge cérémonielle avec médaillon sceau doré officiel",
      "brand.certificateStyle.modern": "Moderne Ardoise",
      "brand.certificateStyle.modernDesc": "Pilier latéral ardoise asymétrique avec typographie alignée à gauche et accent bleu",
      "brand.certificateStyle.luxe": "Or Élégant (Luxe)",
      "brand.certificateStyle.luxeDesc": "Carte flottante sur passe-partout ivoire avec coins biseautés or et cartouches losange",
      "brand.certificateStyle.academic": "Diplôme Académique",
      "brand.certificateStyle.academicDesc": "Bandeau d'en-tête collégial avec doubles piédestaux de signature et sceau officiel",
      "brand.certificateStyle.minimal": "Minimaliste Épuré",
      "brand.certificateStyle.minimalDesc": "Grille typographique suisse épurée avec repères d'angles et matrice de métadonnées",
      "brand.certificateStyleCurrent": "Style actuel : {style}",
      "brand.certificateCustomizeLink": "Personnaliser le logo et le style dans Branding →",
      "nav.products": "Boutique",
      "nav.programs": "Programmes",
      "nav.promos": "Codes promo",
      "nav.giftcards": "Cartes-cadeaux",
      "nav.invoices": "Factures",
      "nav.crm": "CRM",
      "nav.ai": "Assistant IA",
      "nav.automation": "Automation",
      "nav.social": "Réseaux sociaux",
      "nav.branding": "Branding",
      "nav.customDomain": "Domaine personnalisé",
      "nav.billing": "Abonnement",
      "nav.content": "Contenu du site",
      "nav.media": "Médias",
      "nav.siteImages": "Images du site",
      "nav.siteBuilder": "Créer mon site",
      "nav.telehealth": "Téléconsultation",
      "nav.settings": "Paramètres",
      "nav.comingSoon": "Modules à venir",
      "section.addons": "Add-ons",
      "section.config": "Configuration",
      "section.roadmap": "Roadmap",
      "section.practice": "☀ Pratique",
      "section.academy": "☾ Académie",
      "section.intelligence": "✦ Intelligence",
      "section.grow": "✦ Croissance",
      "nav.affiliate": "Affiliation",
      "section.site": "Site & Contenu",
      "nav.learn": "Cours",
      "nav.circle": "Circle",
      "nav.pathways": "Parcours",
      "nav.modalityPacks": "Modalités",
      "banner.managingAs": "Vous gérez {practice} en tant que Super-Admin Solunary",
      "banner.return": "← Retour au Super-Admin",
      "accessDenied.title": "Accès non autorisé",
      "accessDenied.body": "Le compte {email} n'est associé à aucun espace praticien.",
      "accessDenied.hint": "Vérifiez que vous vous connectez avec l'adresse e-mail utilisée lors de l'inscription de votre cabinet.",
      "accessDenied.switchAccount": "Changer de compte",
      "suspended.title": "Compte suspendu",
      "suspended.body": "L'accès au tableau de bord de ce cabinet a été suspendu par Solunary.",
      "suspended.hint": "Contactez le support Solunary pour rétablir l'accès.",
      "choosePractice.title": "Quel cabinet ?",
      "choosePractice.body": "Ce compte est propriétaire de plusieurs cabinets. Choisissez celui à administrer — vous pourrez en changer en vous déconnectant.",
      "noContext.title": "Aucun cabinet sélectionné",
      "noContext.body": "Vous êtes connecté en tant qu'opérateur de la plateforme, mais cette page ne désigne aucun cabinet.",
      "noContext.hint": "Ouvrez le cabinet depuis Super Admin → Cabinets → Gérer l'admin.",
      "entryReserved.title": "Réservé aux Super-Admins",
      "entryReserved.body": "Votre compte d'équipe Solunary ({email}) ne peut pas ouvrir le tableau de bord d'un cabinet : c'est réservé aux Super-Admins.",
      "entryReserved.hint": "Demandez à un Super-Admin si une modification est nécessaire dans ce cabinet, ou connectez-vous avec le compte de votre propre cabinet.",
      "login.errorSuspended": "Ce compte est suspendu : la connexion est bloquée. Contactez le support Solunary pour rétablir l'accès."
  },
  "en": {
      "layout.dashboard": "Dashboard",
      "layout.viewSite": "View site",
      "layout.viewMarketplace": "View marketplace",
      "overview.hello": "Hello",
      "overview.subtitle": "Here's an overview of your site.",
      "overview.siteOnline": "Your site is live",
      "overview.siteOnlineSub": "Change your colors, content and template whenever you want.",
      "overview.editSite": "Edit my site",
      "overview.notPublished": "Site not published",
      "overview.start5min": "5 min to get started",
      "overview.startSub": "Pick a template, customize your colors and publish your site online.",
      "overview.published": "published",
      "overview.active": "active",
      "overview.unread": "unread",
      "overview.pending": "pending",
      "overview.filesUploaded": "uploaded files",
      "actions.save": "Save",
      "actions.saved": "Saved",
      "actions.add": "Add",
      "settings.title": "Site settings",
      "settings.subtitle": "Global settings.",
      "settings.calendly": "Calendly URL (optional)",
      "settings.practiceName.title": "Practice name",
      "settings.practiceName.subtitle": "The name your clients see everywhere: your site, the marketplace, your emails, and their card statement.",
      "settings.practiceName.label": "Practice name",
      "settings.practiceName.hint": "Receipts already issued keep the name they were issued under. If you have filed a tax profile, your receipts use the legal name recorded there.",
      "settings.practiceName.save": "Save name",
      "settings.practiceName.saved": "Name saved",
      "settings.practiceName.tooShort": "A practice name needs at least 2 characters.",
      "settings.practiceName.tooLong": "A practice name cannot exceed 120 characters.",
      "settings.email": "Business email",
      "settings.phone": "Phone (optional)",
      "settings.shopEnabled": "Shop active (publicly visible)",
      "settings.yes": "Yes",
      "settings.no": "No",
      "settings.bookingTermsFr": "Booking terms (FR)",
      "settings.bookingTermsEn": "Booking terms (EN)",
      "avail.error": "Error",
      "bookings.title": "Appointments",
      "bookings.subtitle": "Bookings made by your clients.",
      "bookings.all": "All",
      "bookings.pending": "Pending",
      "bookings.confirmed": "Confirmed",
      "bookings.cancelled": "Cancelled",
      "bookings.empty": "No appointments in this category.",
      "bookings.slot": "Slot",
      "bookings.client": "Client",
      "bookings.roomCreated": "Room created — URL copied and shared",
      "bookings.statusUpdated": "Status updated",
      "bookings.timeTaken": "Its time has since been booked by someone else, so this appointment cannot be restored.",
      "bookings.statusError": "Failed to update status",
      "bookings.startVideo": "Start video consultation",
      "bookings.confirm": "Confirm",
      "bookings.cancel": "Cancel",
      "bookings.statusLabel.pending": "Pending",
      "bookings.statusLabel.confirmed": "Confirmed",
      "bookings.statusLabel.cancelled": "Cancelled",
      "bookings.statusLabel.pending_payment": "Payment pending",
      "bookings.statusLabel.paid_needs_attention": "Paid — needs action",
      "bookings.statusLabel.completed": "Completed",
      "bookings.pendingPayment": "Payment pending",
      "bookings.paidNeedsAttention": "Paid — needs action",
      "bookings.awaitingPayment": "Awaiting payment",
      "bookings.expiresIn": "expires in {min} min",
      "bookings.expired": "expired",
      "bookings.paidWarnTitle": "Cancel this paid appointment?",
      "bookings.paidWarnBody": "The client paid {amount}. Cancelling does NOT refund them — the refund stays a separate action, available right after.",
      "bookings.paidWarnDismiss": "Back",
      "bookings.paidWarnConfirm": "Cancel anyway",
      "bookings.refundFollowupTitle": "Appointment cancelled",
      "bookings.refundFollowupBody": "Refund the {amount} charged now?",
      "bookings.refundLater": "Later",
      "bookings.refundNow": "Refund now",
      "bookings.refundSuccess": "Refund issued",
      "bookings.refundError": "Refund failed",
      "bookings.needsAttentionTitle": "Paid, but no seat left",
      "bookings.needsAttentionBody": "The payment arrived after the hold expired, and its time was booked by someone else in the meantime. The money is captured: keep the appointment (possible only if its time is free again) or refund and cancel.",
      "bookings.keepAppointment": "Keep appointment",
      "bookings.refundAndCancel": "Refund & cancel",
      "cal.title": "Calendar",
      "cal.subtitle": "Your appointments over your opening hours. Drag an appointment to move it.",
      "cal.today": "Today",
      "cal.month": "Month",
      "cal.week": "Week",
      "cal.day": "Day",
      "cal.apptRescheduled": "Appointment moved to {time}",
      "cal.loadError": "Loading error",
      "gcal.title": "Google Calendar",
      "gcal.desc": "Sync your appointments two-way with your Google Calendar.",
      "gcal.connect": "Connect Google Calendar",
      "gcal.connected": "Connected",
      "gcal.connectedAs": "Connected as",
      "gcal.disconnect": "Disconnect",
      "gcal.syncNow": "Sync now",
      "gcal.syncing": "Syncing…",
      "gcal.lastSync": "Last sync",
      "gcal.never": "Never",
      "gcal.syncDone": "Synced: {pushed} appointments pushed, {busy} events imported",
      "gcal.syncPartial": "Incomplete sync: {pushed} pushed, {failed} failed — your Google calendar may be missing appointments",
      "cal.detailDialogDesc": "Appointment details",
      "ovr.dialogDesc": "Add a closed period",
      "gcal.connectedToast": "Google Calendar connected successfully",
      "gcal.errorToast": "Failed to connect Google Calendar",
      "gcal.scopeMissing": "Connection refused: the Calendar permission was not granted. Reconnect and tick Google Calendar access.",
      "gcal.disconnected": "Google Calendar disconnected",
      "gcal.notConfigured": "Google Calendar is not configured on the platform.",
      "gcal.busyLegend": "Google events (busy)",
      "cal.updated": "Updated",
      "cal.video": "Video",
      "cal.confirmDetachCancel": "Cancel",
      "cal.confirmOverrideTitle": "Move it anyway?",
      "cal.confirmOverrideOutsideBody": "This time is outside your published opening hours (weekly schedule, extra hours or a closure). You can move the appointment anyway: it will take place outside your published hours.",
      "cal.confirmOverrideBusyBody": "An external Google event already occupies that time. You can move the appointment anyway: you will have two commitments at once.",
      "cal.confirmOverrideCancel": "Cancel",
      "cal.confirmOverrideConfirm": "Move it anyway",
      "err.gcalNotConnected": "Google Calendar is not connected",
      "err.invalidWindows": "Some time windows are invalid or overlap",
      "err.invalidTimezone": "Invalid timezone",
      "err.invalidRange": "Invalid date range",
      "err.templateNotFound": "No weekly schedule found yet",
      "err.tenantSuspended": "Account suspended: you can view, but changes are blocked. Update billing to reactivate.",
      "err.outsideAvailability": "That time is outside your published availability.",
      "err.targetGcalBusy": "An external Google event already occupies that time.",
      "err.paymentPending": "This appointment is awaiting payment — this action is blocked until it's settled (cancelling or waiting is still possible).",
      "err.consultCharged": "This consultation has already been charged, so it can no longer be cancelled. To give the money back, issue a refund from Payments.",
      "gate.title": "Connect Google Calendar to publish",
      "gate.body": "Publishing your weekly schedule requires a connected Google Calendar so the times offered to clients account for your own calendar and never double-book you.",
      "gcal.disconnectWarnTitle": "Disconnect Google Calendar?",
      "gcal.disconnectWarnBody": "{n} upcoming appointments are synced with Google Calendar. Disconnecting will stop their sync — they'll stay in Solunary but no longer reflect in Google.",
      "gcal.disconnectWarnBodyNone": "No upcoming synced appointments. You can safely disconnect Google Calendar.",
      "sync.busyChecked": "Google busy times checked {time}",
      "sync.busyCheckedNever": "Not checked yet",
      "sync.mismatchPill": "{n} bookings to review",
      "sync.mismatchHelp": "These appointments no longer match your Google Calendar: the event was moved or deleted on the Google side. Open the calendar to review them.",
      "sync.checkNow": "Check now",
      "sync.checking": "Checking…",
      "sync.reconcileToast": "{cancelled} cancelled · {drifted} moved",
      "sync.noneLeft": "No bookings left to review",
      "sync.driftBanner": "This appointment moved in Google Calendar.",
      "sync.driftGoogleTime": "Google Calendar: {time}",
      "sync.driftSolunaryTime": "Solunary: {time}",
      "sync.repush": "Re-push to Google",
      "sync.repushDone": "Re-pushed to Google Calendar",
      "sync.acknowledge": "Acknowledge",
      "sync.ackDone": "Acknowledged",
      "sync.googleCancelledBanner": "This appointment was cancelled from Google Calendar. The client has NOT been notified.",
      "ovr.title": "Blocked dates",
      "ovr.subtitle": "Days you're unavailable, even during your usual hours.",
      "ovr.add": "Block a date",
      "ovr.empty": "No blocked dates yet.",
      "ovr.dateFrom": "From",
      "ovr.dateFromRequired": "Start date is required",
      "ovr.dateTo": "To (optional)",
      "ovr.dateToHint": "Leave empty to block a single day",
      "ovr.reason": "Reason (optional)",
      "ovr.reasonPlaceholder": "e.g. Vacation, day off…",
      "ovr.create": "Block dates",
      "ovr.created": "Dates blocked",
      "ovr.confirmDelete": "Remove this blocked date?",
      "ovr.deleted": "Blocked date removed",
      "ovr.conflicts": "{count} existing booking(s) fall inside this range",
      "ovr.dialogTitle": "Block dates",
      "sched.pageTitle": "Availability settings",
      "sched.pageSubtitle": "Set your opening hours and the services they offer: clients pick a service, then a start time.",
      "sched.viewCalendarLink": "View calendar",
      "sched.settingsTitle": "Weekly schedule",
      "sched.timezone": "Timezone",
      "sched.statusDraft": "Draft",
      "sched.statusPublished": "Published",
      "sched.save": "Save",
      "sched.saved": "Schedule saved",
      "sched.publish": "Publish",
      "sched.published": "Schedule published",
      "sched.publishNeedsConnect": "Connect Google Calendar to publish your schedule",
      "sched.publishNeedsSave": "Save your changes before publishing",
      "sched.dirty": "Unsaved changes",
      "sched.loadError": "Could not load your schedule",
      "sched.windowOverlap": "Some time windows overlap",
      "sched.windowInvalid": "End time must be after start time",
      "sched.addWindow": "Add a window",
      "sched.dayClosed": "Closed",
      "msg.title": "Messages",
      "msg.subtitle": "Your conversations with your clients.",
      "msg.empty": "No conversations yet.",
      "msg.selectToRead": "Select a conversation to read it.",
      "msg.noMessagesYet": "No messages in this conversation.",
      "msg.loadOlder": "Show older messages",
      "msg.reply": "Your reply",
      "msg.replyPlaceholder": "Write your reply…",
      "msg.send": "Send",
      "msg.sending": "Sending…",
      "msg.you": "You",
      "msg.client": "Client",
      "msg.charCount": "{n}/{max}",
      "msg.unread": "Unread",
      "msg.unreadOne": "1 unread message",
      "msg.unreadMany": "{n} unread messages",
      "testi.title": "Testimonials",
      "testi.subtitle": "Add client reviews shown on your site.",
      "testi.new": "New",
      "testi.empty": "No custom testimonials yet. The default testimonials still appear on the site.",
      "testi.active": "Active",
      "testi.hidden": "Hidden",
      "testi.order": "Order",
      "testi.confirmDelete": "Delete {name}'s testimonial?",
      "testi.newTitle": "New testimonial",
      "testi.editTitle": "Edit",
      "testi.field.name": "Name",
      "testi.field.link": "Link (Google Maps)",
      "testi.field.quoteFr": "Quote (FR)",
      "testi.field.quoteEn": "Quote (EN)",
      "testi.field.charCount": "{count} / {max} characters",
      "testi.field.status": "Status",
      "blog.title": "Journal posts",
      "blog.subtitle": "Create, edit and publish your posts.",
      "blog.new": "New post",
      "blog.empty": "No posts yet.",
      "blog.published": "Published",
      "blog.draft": "Draft",
      "blog.untitled": "Untitled",
      "blog.confirmDelete": "Delete \"{title}\"?",
      "blog.saveError": "Error while saving",
      "blog.editTitle": "Edit",
      "blog.newTitle": "New post",
      "blog.field.titleFr": "Title (FR)",
      "blog.field.tagFr": "Tag (FR)",
      "blog.field.excerptFr": "Excerpt (FR)",
      "blog.field.bodyFr": "Content (FR)",
      "blog.field.titleEn": "Title (EN)",
      "blog.field.tagEn": "Tag (EN)",
      "blog.field.excerptEn": "Excerpt (EN)",
      "blog.field.bodyEn": "Body (EN)",
      "blog.field.slug": "Slug",
      "blog.field.cover": "Cover image",
      "blog.field.status": "Status",
      "blog.upload": "Upload",
      "branding.subtitle": "Customize your public site's visual identity.",
      "branding.saved": "Branding saved",
      "branding.imageUploaded": "Image uploaded",
      "branding.urlError": "URL not retrieved",
      "branding.uploadError": "Upload error",
      "branding.identity": "Identity",
      "branding.tagline": "Tagline (under the main title)",
      "branding.taglinePlaceholder": "A journey to natural wellness",
      "branding.specialties": "Specialties (shown in the Solunary marketplace)",
      "content.title": "Site content",
      "content.subtitle": "Edit your homepage text, section by section, in the order your visitors read it. A field left empty shows the sample text, unless its note says otherwise.",
      "content.confirmDelete": "Delete the \"{key}\" customization?",
      "content.addCustom": "Add a custom key",
      "content.addCustomHint": "Optional · Advanced setting only needed if you want to override a specific template key.",
      "content.create": "Create",
      "content.customPrefix": "Custom",
      "content.frPlaceholder": "FR text (empty = default)",
      "content.enPlaceholder": "EN text (empty = default)",
      "content.preset.hero.eyebrow": "Hero · Badge above the title",
      "content.preset.hero.script": "Hero · Handwritten phrase",
      "content.preset.hero.sub": "Hero · Subtitle",
      "content.preset.story.eyebrow": "My journey · Label above the title",
      "content.preset.story.title": "My journey · Title",
      "content.preset.story.lead": "My journey · Intro",
      "content.preset.approach.eyebrow": "Approach · Label above the title",
      "content.preset.approach.title": "Approach · Title",
      "content.preset.approach.lead": "Approach · Intro",
      "content.preset.services.lead": "Services · Intro",
      "content.preset.contact.lead": "Contact · Intro",
      "content.preset.contact.email": "Contact · Email",
      "content.preset.contact.place": "Contact · Location",
      "content.section.hero": "Hero section",
      "content.section.story": "My journey section",
      "content.section.approach": "Approach section",
      "content.section.services": "Services section",
      "content.section.contact": "Contact section",
      "nav.overview": "Overview",
      "nav.siteBuilder": "Build my site",
      "nav.learn": "Courses",
      "nav.telehealth": "Telehealth",
      "nav.blog": "Blog",
      "nav.testimonials": "Testimonials",
      "nav.messages": "Messages",
      "nav.availability": "Availability",
      "nav.bookings": "Bookings",
      "nav.calendar": "Calendar",
      "nav.customers": "My Clients",
      "nav.quizReviews": "Quiz reviews",
      "nav.learnAnalytics": "Learn analytics",
      "nav.payments": "Payments",
      "nav.taxConfig": "Taxes",
      "learn.title": "Solunary Learn",
      "learn.newCourse": "New course",
      "learn.editCourse": "Edit course",
      "learn.addLesson": "Lesson",
      "learn.addQuiz": "Quiz",
      "learn.published": "Published",
      "learn.publishBtn": "Publish",
      "learn.unpublishBtn": "Unpublish",
      "learn.draft": "Draft",
      "learn.price": "Price",
      "learn.currency": "Currency",
      "learn.free": "Free",
      "learn.mandatory": "Mandatory",
      "learn.lesson": "Lesson",
      "learn.quiz": "Quiz",
      "learn.markComplete": "Mark as complete",
      "learn.completed": "Lesson completed",
      "learn.locked": "Lesson locked",
      "learn.lockedDesc": "Complete the previous mandatory lesson to unlock this one.",
      "learn.quizSubmit": "Submit quiz",
      "learn.quizRetry": "Retake quiz",
      "learn.quizPassed": "Quiz passed!",
      "learn.quizFailed": "Score below threshold",
      "learn.answerAll": "Answer all questions to submit.",
      "learn.openAnswerHint": "Open answer — will be reviewed by the practitioner",
      "learn.openAnswerPlaceholder": "Your answer…",
      "learn.enrollPrice": "Buy and access",
      "learn.enrollFree": "Start course",
      "learn.emailPlaceholder": "your.email@example.com",
      "learn.coursesWord": "courses",
      "learn.sellHint": "Create and sell your courses.",
      "learn.fieldTitle": "Title *",
      "learn.fieldDescription": "Description",
      "learn.coverUrl": "Cover image (URL)",
      "learn.freeHint": "0 = free",
      "learn.pricePlaceholder": "0.00 = free",
      "learn.publishLabel": "Publish the course (publicly visible and in the Solunary marketplace)",
      "learn.lessonsWord": "Lessons",
      "learn.noLessons": "No lessons. Add a Lesson (video/text content) or a Quiz.",
      "learn.publishNeedsLesson": "Add at least one lesson to publish this course.",
      "learn.lastLessonPublished": "A published course needs at least one lesson — unpublish it first.",
      "learn.publishedEmptyWarning": "Published with no lessons: nobody can buy it. Add a lesson or unpublish it.",
      "learn.publishedToast": "Course published.",
      "learn.unpublishedToast": "Course unpublished.",
      "learn.coursesEmpty": "Your 1:1 work is already course material. Let Solunary AI turn your protocols into your first cohort.",
      "learn.editBtn": "Edit",
      "learn.titlePlaceholderQuiz": "Quiz title",
      "learn.titlePlaceholderLesson": "Lesson title",
      "learn.mandatoryDescQuiz": "Mandatory — locks the following lessons until it is passed",
      "learn.mandatoryDescLesson": "Mandatory — locks the following lessons until it is completed",
      "learn.videoPlaceholder": "Video URL (YouTube embed, Vimeo, hosted MP4)",
      "learn.lessonBodyPlaceholder": "Lesson text (optional)",
      "learn.passThreshold": "Pass threshold",
      "learn.durationLabel": "Duration",
      "learn.minutesSuffix": "min",
      "learn.qOpen": "open",
      "learn.qMcq": "MCQ",
      "learn.questionPlaceholder": "Question…",
      "learn.openAnswerDesc": "The student will answer with free text. Auto-credited on submission; you can review answers in the client file.",
      "learn.markCorrect": "Mark as correct answer",
      "learn.choiceWord": "Choice",
      "learn.addChoice": "+ Add a choice",
      "learn.mcq": "MCQ",
      "learn.longAnswer": "Long answer",
      "learn.addQuestionHint": "Add at least one question for this quiz.",
      "learn.titleRequired": "Title required",
      "learn.quizTitleRequired": "Give this quiz a title before saving.",
      "learn.saved": "Course saved",
      "learn.confirmDelete": "Delete this course?",
      "learn.error": "Error",
      "promos.title": "Promo codes",
      "promos.subtitle": "Create percentage or fixed-amount codes.",
      "promos.code": "Code",
      "promos.type": "Type",
      "promos.percentage": "Percentage (%)",
      "promos.fixed": "Fixed amount ($)",
      "promos.maxUses": "Max uses (0 = unlimited)",
      "promos.create": "Create",
      "promos.empty": "No promo codes yet.",
      "promos.confirmDelete": "Delete?",
      "promos.discountPct": "{value}% off",
      "promos.discountFixed": "${value} off",
      "promos.uses": "uses",
      "promos.active": "active",
      "promos.inactive": "inactive",
      "gift.title": "Gift cards",
      "gift.subtitle": "Issue cards manually, or view those sold online.",
      "gift.issueCard": "Issue a card",
      "gift.value": "Value (cents, e.g. 5000 = $50)",
      "gift.recipientEmail": "Recipient email",
      "gift.recipientName": "Recipient name",
      "gift.message": "Message",
      "gift.issue": "Issue",
      "gift.empty": "No gift cards yet.",
      "gift.balance": "Balance",
      "gift.soldOnline": "Sold online",
      "gift.issuedManually": "Issued manually",
      "gift.confirmCancel": "Cancel this card?",
      "gift.valueTooSmall": "Enter a value of at least {min} {currency}.",
      "shop.title": "Shop",
      "shop.subtitle": "Stripe products and affiliate links.",
      "shop.activePublic": "Shop publicly active",
      "shop.new": "New",
      "shop.empty": "No products yet.",
      "shop.active": "Active",
      "shop.inactive": "Inactive",
      "shop.affiliate": "Affiliate",
      "shop.externalLink": "External link",
      "shop.confirmDelete": "Delete?",
      "shop.newProduct": "New product",
      "shop.edit": "Edit",
      "shop.nameFr": "Name (FR)",
      "shop.nameEn": "Name (EN)",
      "shop.descFr": "Description (FR)",
      "shop.descEn": "Description (EN)",
      "shop.type": "Type",
      "shop.typeStripe": "Stripe (direct sale)",
      "shop.typeAffiliate": "Affiliate link (e.g. Amazon)",
      "shop.productType": "Product nature",
      "shop.productTypePhysical": "Physical (shipped)",
      "shop.productTypeDigital": "Digital (download or access)",
      "shop.price": "Price ($)",
      "shop.affiliateUrl": "Affiliate URL",
      "shop.image": "Image",
      "shop.upload": "Upload",
      "shop.order": "Order",
      "shop.cancel": "Cancel",
      "shop.save": "Save",
      "tele.title": "Telehealth",
      "tele.subtitle": "Your video consultations: your room and every consultation you have run.",
      "tele.empty": "No consultation yet — they appear here as soon as a client books.",
      "tele.videoProvider": "Video provider",
      "tele.videoProviderNote": "Every one of your consultation rooms is opened with this provider. Solunary manages it — there is nothing for you to configure.",
      "mod.title": "Care modalities",
      "mod.subtitle": "Choose your modality: intake forms, taxonomy and tailored protocols. The active modality constrains the Solunary AI assistant to its scope.",
      "mod.error": "Error",
      "mod.added": "Modality added",
      "mod.activated": "Modality activated — the AI is now constrained to this scope",
      "mod.confirmRemove": "Remove this modality?",
      "mod.myModalities": "My modalities",
      "mod.active": "Active",
      "mod.activate": "Activate",
      "mod.intake": "Intake ({count} fields)",
      "mod.protocols": "Protocols",
      "mod.steps": "steps",
      "mod.catalog": "Modality catalog",
      "mod.add": "Add",
      "mod.allAdded": "All modalities are added.",
      "ai.title": "AI Assistant",
      "ai.subtitle": "Powered by Claude Sonnet 4.5. Write, summarize, brainstorm — in seconds.",
      "ai.task.write_article": "Write an article",
      "ai.task.draft_reply": "Draft a reply",
      "ai.task.summarize_messages": "Summarize messages",
      "ai.task.free_form": "Free question",
      "ai.ph.write_article": "Article topic (e.g. benefits of intermittent fasting)",
      "ai.ph.draft_reply": "Paste the message to reply to here...",
      "ai.ph.summarize_messages": "Paste several messages, I'll give you an actionable summary.",
      "ai.ph.free_form": "Whatever you want...",
      "ai.promptRequired": "Enter a prompt",
      "ai.error": "AI error",
      "ai.copied": "Copied!",
      "ai.yourInput": "Your input",
      "ai.generate": "Generate",
      "ai.response": "AI response",
      "ai.copy": "Copy",
      "insights.title": "Solunary Insights",
      "insights.subtitle": "Daily AI briefing",
      "insights.refresh": "Refresh",
      "insights.generating": "Generating briefing...",
      "insights.draft": "AI draft — verify before acting",
      "insights.bookingsUpcoming": "Upcoming appts",
      "insights.currentLeads": "Leads to follow up",
      "insights.scheduledPosts": "Scheduled posts",
      "insights.automationRuns": "Autom. (7d)",
      "insights.cachedToday": "Cached today",
      "insights.justNow": "Generated just now",
      "insights.poweredBy": "Powered by Claude Sonnet 4.5",
      "lan.title": "Solunary Learn Analytics",
      "lan.subtitle": "Overview of your courses' performance.",
      "lan.courses": "Courses",
      "lan.published": "{count} published",
      "lan.students": "Students",
      "lan.enrollments": "Enrollments",
      "lan.revenue": "Revenue",
      "lan.paidCourses": "Paid courses",
      "lan.perCourse": "Per-course performance",
      "lan.empty": "No courses. Create your first course in Solunary Learn.",
      "lan.colCourse": "Course",
      "lan.colStatus": "Status",
      "lan.colStudents": "Students",
      "lan.colCompleted": "Completed",
      "lan.colProgress": "Avg. progress",
      "lan.colQuiz": "Avg. quiz score",
      "lan.colRevenue": "Revenue",
      "lan.statusPublished": "Published",
      "lan.statusDraft": "Draft",
      "tax.loadError": "Loading error",
      "tax.presetApplied": "Preset applied — don't forget to save",
      "tax.saved": "Tax configuration saved ✓",
      "tax.error": "Error",
      "tax.title": "Tax configuration",
      "tax.subtitle": "Define the taxes applied to your courses, products and consultations. Shown on every invoice.",
      "tax.lines": "Tax lines",
      "tax.add": "Add",
      "tax.presets": "Common presets",
      "tax.empty": "No tax configured. Your clients pay the listed price with no surcharge.",
      "tax.namePh": "Name (GST, VAT…)",
      "tax.ratePh": "Rate %",
      "tax.regPh": "Registration no. (optional)",
      "tax.inclusive": "Prices shown on my site already include taxes (incl. tax)",
      "tax.save": "Save",
      "tax.previewTitle": "Preview on a $100.00 course",
      "tax.subtotal": "Price excl. tax (subtotal)",
      "tax.totalCharged": "Total charged to client",
      "tax.commission": "Solunary commission ({pct}%)",
      "tax.net": "Net for you",
      "pay.error": "Error",
      "pay.paypalConnected": "PayPal connected ✓",
      "pay.confirmDisconnect": "Disconnect {name}?",
      "pay.disconnected": "Disconnected",
      "pay.title": "Payments",
      "pay.subtitle": "Connect your Stripe account to receive your payouts — Solunary collects your clients' payments and pays your share out to you.",
      "pay.paypal.desc": "Your clients pay with PayPal, card or Pay in 4. International network.",
      "pay.blockedBySolunary": "Disabled by Solunary",
      "pay.connected": "Connected",
      "pay.merchant": "Merchant:",
      "pay.environment": "Environment:",
      "pay.unavailableShort": "Unavailable",
      "pay.disconnect": "Disconnect",
      "pay.docs": "Docs",
      "pay.howItWorks": "How it works:",
      "pay.howItWorksText": " When a client pays for a course, product or consultation, Solunary collects the payment. Your share (the total minus the platform commission) is then paid out to your connected Stripe account — the “Owed by Solunary / Paid out to date” strip below tracks those amounts.",
      "dom.copied": "Copied",
      "dom.hostName": "Host / Name",
      "dom.valueTarget": "Value / Target",
      "dom.copyValue": "Copy value",
      "dom.error": "Error",
      "dom.enterDomain": "Enter a domain",
      "dom.saved": "Domain saved — configure DNS then verify",
      "dom.title": "Custom domain",
      "dom.subtitle": "Use your own address (e.g. www.myclinic.com) for your Solunary site.",
      "dom.yourDomain": "Your domain",
      "dom.domain": "Domain",
      "dom.save": "Save",
      "dom.dnsSteps": "DNS configuration steps",
      "dom.step1": "Log in to your registrar (OVH, GoDaddy, Cloudflare…).",
      "dom.step2": "Add the two records below.",
      "dom.verify": "Verify",
      "dom.lastCheck": "Last check:",
      "auto.ruleSaved": "Rule saved",
      "auto.error": "Error",
      "auto.confirmDelete": "Delete this rule?",
      "auto.deleted": "Deleted",
      "auto.title": "Automation",
      "auto.subtitle": "{rules} rules · {runs} recent runs",
      "auto.newRule": "New rule",
      "auto.tabRules": "Rules",
      "auto.tabHistory": "History",
      "auto.empty": "No rules. Click \"New rule\" to automate your workflows.",
      "auto.trigger": "Trigger:",
      "auto.disable": "Disable",
      "auto.enable": "Enable",
      "auto.edit": "Edit",
      "auto.runsCount": "Ran {count} times",
      "auto.lastRun": "last:",
      "auto.modalTitleEdit": "Edit rule",
      "auto.modalTitleNew": "New rule",
      "auto.name": "Name",
      "auto.triggerLabel": "Trigger (event)",
      "auto.actionsLabel": "Actions (run in order)",
      "auto.addAction": "Add an action",
      "auto.active": "Active",
      "auto.save": "Save",
      "auto.cancel": "Cancel",
      "auto.colDate": "Date",
      "auto.colRule": "Rule",
      "auto.colTrigger": "Trigger",
      "auto.colResults": "Results",
      "auto.noRuns": "No runs.",
      "social.demoAccount": "Demo account created",
      "social.oauthError": "OAuth error",
      "social.confirmDisconnect": "Disconnect this account?",
      "social.accountDisconnected": "Account disconnected",
      "social.publishedOn": "Published to {ok}/{total} account(s){demo}",
      "social.demoSuffix": " (demo mode)",
      "social.publishError": "Publishing error",
      "social.postSaved": "Post saved",
      "social.error": "Error",
      "social.confirmDeletePost": "Delete this post?",
      "social.topicRequired": "Enter a topic",
      "social.draftGenerated": "Draft generated — validate before using",
      "social.aiError": "AI error",
      "social.draftApproved": "Draft approved and inserted",
      "social.describeImage": "Describe the image",
      "social.imageGenerated": "Image generated",
      "social.title": "Social Media",
      "social.subtitle": "{total} posts · {scheduled} scheduled · {drafts} drafts",
      "social.all": "All",
      "social.newPost": "New post",
      "social.connectedAccounts": "Connected accounts ({count})",
      "social.demo": "(demo)",
      "social.noAccounts": "No connected account. Click a platform above to get started.",
      "social.demoParen": "(demo)",
      "social.platforms": "Platforms",
      "social.genWithAi": "Generate with AI",
      "social.topicPh": "Post topic (e.g. benefits of ginger in autumn)",
      "social.genText": "Generate text",
      "social.noTextWithoutValidation": "No text reaches a client without validation",
      "social.approveUse": "Approve & use",
      "social.reject": "Reject",
      "social.imageOptional": "Image (optional)",
      "social.imagePh": "Describe the image (e.g. steaming herbal tea in a ceramic mug)",
      "social.genImage": "Generate image",
      "social.modalEditPost": "Edit post",
      "social.modalNewPost": "New post",
      "social.content": "Content",
      "social.status": "Status",
      "social.scheduledDate": "Scheduled date",
      "social.save": "Save",
      "social.cancel": "Cancel",
      "social.edit": "Edit",
      "social.publish": "Publish",
      "social.emptyPosts": "No posts yet.",
      "bill.error": "Error",
      "bill.demoPortal": "Stripe in demo mode — portal unavailable. Use \"Change plan\" below.",
      "bill.stripeError": "Stripe error",
      "bill.planUpdated": "Plan updated",
      "bill.title": "Subscription & billing",
      "bill.subtitle": "Manage your plan, currency and payments.",
      "bill.changePlan": "Change plan",
      "bill.stripePortal": "Stripe portal",
      "bill.demoTitle": "Stripe demo mode",
      "bill.demoText": " — plan changes are applied immediately without real payment. To go to production, configure a real Stripe key.",
      "bill.currentPlan": "Current plan",
      "bill.cycle.perMonth": "per month",
      "bill.customPrice.label": "Negotiated price",
      "bill.customPrice.chip": "Negotiated price",
      "bill.customPrice.until": "until {date}",
      "bill.cycle.perYear": "per year",
      "bill.customPrice.planChangeEnds": "Changing plan ends your negotiated price of {price}. The new plan is billed at its normal price.",
      "bill.customPrice.endedByPlanChange": "Plan updated. Your negotiated price no longer applies.",
      "bill.err.billingChangeInProgress": "A billing change is already being applied to your subscription. Try again in a few minutes.",
      "bill.err.practiceDeletionPending": "This practice is being deleted: no purchase can be opened for it.",
      "bill.activatedOn": "Activated on",
      "bill.currency": "Currency",
      "bill.stripeCustomer": "Stripe Customer",
      "bill.from": "From {price}",
      "bill.activeAddons": "Active paid add-ons",
      "bill.services.title": "Solunary Services",
      "bill.services.subtitle": "Done-for-you services to accelerate your practice. Express your interest — our team will reach out.",
      "bill.services.thanks": "Thank you! The Solunary team will contact you.",
      "bill.services.interestSent": "Interest sent",
      "bill.services.contactUs": "Contact us",
      "bill.services.pulse.desc": "Monthly account audit & health, prioritized recommendations.",
      "bill.services.grow.desc": "Growth support: funnels, content, campaigns.",
      "bill.services.studio.desc": "Creative production: design, video, turnkey courses.",
      "bill.services.concierge.desc": "Delegated operational management of your practice.",
      "bill.services.executive.desc": "Dedicated strategic partnership, executive level.",
      "bill.boosterActivated": "Booster activated!",
      "bill.purchaseConfirmed": "Purchase confirmed!",
      "bill.purchaseCancelled": "Purchase cancelled",
      "bill.confirmCancelBooster": "Deactivate the \"{name}\" booster?",
      "bill.boosterDeactivated": "Booster deactivated",
      "bill.boosters": "Boosters",
      "bill.boostersSub": "Recurring add-ons to extend your plan (billed monthly).",
      "bill.deactivate": "Deactivate",
      "bill.subscribe": "Subscribe",
      "bill.active": "Active",
      "bill.packages": "Packages & setup",
      "bill.packagesSub": "Turnkey services, one-time payment.",
      "bill.porting": "Data migration (Porting)",
      "bill.portingSub": "Import your data from your previous tool.",
      "bill.startingAt": "from ",
      "bill.owned": "Owned",
      "bill.buy": "Buy",
      "bill.recentTx": "Recent transactions",
      "bill.noTx": "No transactions.",
      "bill.colDate": "Date",
      "bill.colType": "Type",
      "bill.colAmount": "Amount",
      "bill.colStatus": "Status",
      "bill.txSubscription": "subscription",
      "bill.changePlanTitle": "Change plan",
      "bill.changePlanSub": "Choose your new plan. Changes are prorated.",
      "bill.planActive": "Active plan",
      "bill.upgradeTo": "Upgrade to this plan",
      "bill.downgrade": "Downgrade",
      "bill.consolidated": "Consolidated invoice",
      "bill.fourStreams": "Solunary's 4 streams · one invoice",
      "bill.subscriptionLabel": "Subscription — {name}",
      "bill.annualBilling": "Annual billing (2 months free)",
      "bill.monthlyBilling": "Monthly billing",
      "bill.addons": "Add-ons",
      "bill.none": "None",
      "bill.platformFees": "Platform fees collected",
      "bill.platformFeesSub": "Solunary Pay / Course Pay (for reference)",
      "bill.solunaryServices": "Solunary Services",
      "bill.interestsCount": "{count} interest(s)",
      "bill.oneTimeRecent": "One-time purchases (recent)",
      "bill.recurringTotal": "Recurring total",
      "bill.perYear": "/yr",
      "bill.perMonth": "/mo",
      "login.title": "Dashboard",
      "login.subtitle": "Sign in to manage your site.",
      "login.error": "Sign-in failed. Try again.",
      "login.continueGoogle": "Continue with Google",
      "login.restricted": "Restricted access — site administrator only.",
      "coming.title": "Upcoming modules",
      "coming.subtitle": "The public roadmap. Vote for those you find most useful — we prioritize by usage.",
      "coming.voteToast": "Vote recorded for \"{title}\" — thank you!",
      "coming.vote": "Vote for this module",
      "coming.alreadyVoted": "Already voted — thank you!",
      "coming.voteError": "Your vote could not be recorded. Please try again.",
      "coming.shipped": "Already available",
      "coming.ideaTitle": "An idea for a missing module?",
      "coming.ideaText": "Solunary is built with and for practitioners. If something slows you down daily, we want to know.",
      "coming.suggest": "Suggest an idea",
      "coming.calsync.title": "2-way calendar sync",
      "coming.calsync.cat": "Calendar",
      "coming.calsync.desc": "Google Calendar & Microsoft/Outlook sync: your appointments and availability synced in real time.",
      "coming.social.title": "Social logins",
      "coming.social.cat": "Authentication",
      "coming.social.desc": "Sign up/sign in via Google, Facebook and LinkedIn for you and your clients.",
      "coming.multi.title": "Advanced multi-practitioner",
      "coming.multi.cat": "Team & roles",
      "coming.multi.desc": "Fine-grained roles (admin, practitioner, receptionist), per-module permissions, audit log.",
      "coming.workflows.title": "Visual workflows",
      "coming.workflows.cat": "Automation Pro",
      "coming.workflows.desc": "Multi-step visual builder (n8n-style) with conditional branches and delays.",
      "coming.emr.title": "EMR/EHR integrations",
      "coming.emr.cat": "Health interoperability",
      "coming.emr.desc": "HL7 FHIR, Practice Better, Jane sync, HIPAA/PHIPA compliance exports.",
      "qr.statusPending": "To review",
      "qr.statusApproved": "Approved",
      "qr.statusRejected": "Rejected",
      "qr.error": "Error",
      "qr.marked": "Marked: {status}",
      "qr.title": "Quiz reviews",
      "qr.subtitle": "{pending} to review · {approved} approved · {rejected} rejected",
      "qr.filterAll": "All",
      "qr.empty": "No long answers to review.",
      "qr.mcqScore": "MCQ score: {score}% · {result}",
      "qr.passed": "passed",
      "qr.failed": "failed",
      "qr.lesson": "Lesson:",
      "qr.student": "Student:",
      "qr.approve": "Approve",
      "qr.reject": "Reject",
      "qr.question": "Question",
      "qr.studentAnswer": "Student's answer",
      "qr.noAnswer": "No answer",
      "sconn.active": "Active",
      "sconn.toFinalize": "To finalize",
      "sconn.notConnected": "Not connected",
      "sconn.desc": "Receive the payouts from your sales on your Stripe account. Solunary collects each sale, then pays your share out to you after a hold period. The platform fee is {fee}.",
      "sconn.descVaries": "Receive the payouts from your sales on your Stripe account. Solunary collects each sale, then pays your share out to you after a hold period. The platform fee depends on what you are selling:",
      "sconn.feeScopeNote": "Your available balance, the hold period and your payout history are in your wallet, further down this page.",
      "sconn.svc.course": "Courses",
      "sconn.svc.booking": "Appointments",
      "sconn.svc.product": "Products",
      "sconn.svc.program": "Programmes",
      "sconn.svc.invoice": "Invoices",
      "sconn.svc.telehealth": "Telehealth",
      "sconn.blocked.no_account": "Your Stripe account is not connected yet.",
      "sconn.blocked.payouts_disabled": "Stripe has suspended your payouts.",
      "sconn.blocked.transfers_inactive": "Stripe has not yet enabled your account to receive funds.",
      "sconn.blocked.requirements_past_due": "Documents are overdue: Stripe is holding your payouts until they arrive.",
      "sconn.reqTitle": "Stripe still needs:",
      "sconn.reqDisabledReason": "Stripe's reason:",
      "sconn.req.external_account": "Your bank account details",
      "sconn.req.individual.verification.document": "An identity document",
      "sconn.req.individual.id_number": "Your identification number",
      "sconn.req.business_profile.url": "Your website address",
      "sconn.req.business_profile.mcc": "Your line of business",
      "sconn.account": "Account:",
      "sconn.payments": "Payments:",
      "sconn.payouts": "Payouts:",
      "sconn.demoNote": "Demo mode — Stripe Connect is not configured on the platform.",
      "sconn.blockedNote": "This payment method has been disabled by Solunary administration.",
      "sconn.manage": "Manage my account",
      "sconn.finalize": "Finalize onboarding",
      "sconn.connect": "Connect Stripe",
      "sconn.docs": "Docs",
      "sconn.returnToast": "Back from Stripe — refreshing status…",
      "sconn.error": "Error",
      "sconn.unavailable": "Stripe Connect unavailable",
      "brand.preview": "Preview",
      "brand.myClinic": "My clinic",
      "brand.taglineHere": "Tagline here",
      "brand.book": "Book",
      "brand.viewFullSite": "View full site →",
      "brand.palette": "Palette",
      "brand.presetDefault": "Solunary (default)",
      "brand.colorPrimary": "Primary (dark)",
      "brand.colorAccent": "Accent (warm)",
      "brand.colorSecondary": "Secondary",
      "brand.images": "Images",
      "brand.logoLabel": "Logo (square, ≥256×256px)",
      "brand.heroLabel": "Hero image (landscape, ≥1600×900px)",
      "brand.remove": "Remove",
      "brand.clickUpload": "Click to upload",
      "brand.orPasteUrl": "or paste a URL",
      "brand.specialtyPlaceholder": "+ Specialty (Enter to confirm)",
      "brand.add": "Add",
      "brand.suggestions": "Suggestions",
      "brand.social": "Social links",
      "brand.socialHint": "These links appear in your public site's footer. Leave the networks you do not use empty — no icon is shown for them.",
      "brand.certificateTitle": "Completion Certificates",
      "brand.certificateSubtitle": "Customize the logo and design style of your pathway completion certificates.",
      "brand.certificateLogoLabel": "Custom certificate logo",
      "brand.certificateLogoHint": "Leave empty to use your main brand logo automatically.",
      "brand.certificateStyleLabel": "Design style",
      "brand.certificatePreviewBtn": "Preview certificate (PDF)",
      "brand.certificateStyle.classic": "Solunary Sage (Classic)",
      "brand.certificateStyle.classicDesc": "Ceremonial double border with official vector gold rosette seal medallion",
      "brand.certificateStyle.modern": "Modern Slate",
      "brand.certificateStyle.modernDesc": "Architectural dark slate sidebar pillar with flush-left typography and bold accent line",
      "brand.certificateStyle.luxe": "Luxe Gold",
      "brand.certificateStyle.luxeDesc": "Elevated 3D floating card on ivory mat with chamfered gold corners and diamond cartouches",
      "brand.certificateStyle.academic": "Academic Diploma",
      "brand.certificateStyle.academicDesc": "Collegiate institutional header banner with formal twin signature and validation pedestals",
      "brand.certificateStyle.minimal": "Minimalist Clean",
      "brand.certificateStyle.minimalDesc": "Swiss editorial typographic grid with registration marks and modular 3-column metadata",
      "brand.certificateStyleCurrent": "Current style: {style}",
      "brand.certificateCustomizeLink": "Customize certificate logo and style in Branding →",
      "nav.products": "Shop",
      "nav.programs": "Programs",
      "nav.promos": "Promo codes",
      "nav.giftcards": "Gift cards",
      "nav.invoices": "Invoices",
      "nav.crm": "CRM",
      "nav.ai": "AI Assistant",
      "nav.automation": "Automation",
      "nav.social": "Social Media",
      "nav.branding": "Branding",
      "nav.customDomain": "Custom domain",
      "nav.billing": "Subscription",
      "nav.content": "Site content",
      "nav.media": "Media",
      "nav.siteImages": "Site images",
      "nav.settings": "Settings",
      "nav.comingSoon": "Coming soon",
      "section.addons": "Add-ons",
      "section.config": "Configuration",
      "section.roadmap": "Roadmap",
      "section.practice": "☀ Practice",
      "section.academy": "☾ Academy",
      "section.intelligence": "✦ Intelligence",
      "section.grow": "✦ Growth",
      "nav.affiliate": "Affiliate",
      "nav.circle": "Circle",
      "section.site": "Site & Content",
      "nav.pathways": "Pathways",
      "nav.modalityPacks": "Modalities",
      "banner.managingAs": "You are managing {practice} as Solunary Super-Admin",
      "banner.return": "← Back to Super-Admin",
      "accessDenied.title": "Unauthorized access",
      "accessDenied.body": "The account {email} is not linked to any practitioner space.",
      "accessDenied.hint": "Make sure you're signing in with the email address used when you registered your practice.",
      "accessDenied.switchAccount": "Switch account",
      "suspended.title": "Account suspended",
      "suspended.body": "Access to this practice's dashboard has been suspended by Solunary.",
      "suspended.hint": "Contact Solunary support to restore access.",
      "choosePractice.title": "Which practice?",
      "choosePractice.body": "This account owns several practices. Choose the one to administer — sign out to switch to another.",
      "noContext.title": "No practice selected",
      "noContext.body": "You are signed in as a platform operator, but this page does not name a practice.",
      "noContext.hint": "Open the practice from Super Admin → Practices → Manage admin.",
      "entryReserved.title": "Reserved for Super-Admins",
      "entryReserved.body": "Your Solunary team account ({email}) cannot open a practice's dashboard: that is reserved for Super-Admins.",
      "entryReserved.hint": "Ask a Super-Admin if a change is needed in this practice, or sign in with your own practice's account.",
      "login.errorSuspended": "This account is suspended: sign-in is blocked. Contact Solunary support to restore access."
  },
  "es": {
      "layout.dashboard": "Panel",
      "layout.viewSite": "Ver el sitio",
      "layout.viewMarketplace": "Ver el mercado",
      "overview.hello": "Hola",
      "overview.subtitle": "Aquí tienes un resumen de tu sitio.",
      "overview.siteOnline": "Tu sitio está en línea",
      "overview.siteOnlineSub": "Cambia tus colores, contenidos y plantilla cuando quieras.",
      "overview.editSite": "Editar mi sitio",
      "overview.notPublished": "Sitio no publicado",
      "overview.start5min": "5 min para empezar",
      "overview.startSub": "Elige una plantilla, personaliza tus colores y publica tu sitio en línea.",
      "overview.published": "publicados",
      "overview.active": "activos",
      "overview.unread": "no leídos",
      "overview.pending": "pendientes",
      "overview.filesUploaded": "archivos subidos",
      "actions.save": "Guardar",
      "actions.saved": "Guardado",
      "actions.add": "Añadir",
      "settings.title": "Ajustes del sitio",
      "settings.subtitle": "Ajustes globales.",
      "settings.calendly": "URL de Calendly (opcional)",
      "settings.practiceName.title": "Nombre de la práctica",
      "settings.practiceName.subtitle": "El nombre que tus clientes ven en todas partes: tu sitio, el mercado, tus correos y el extracto de su tarjeta.",
      "settings.practiceName.label": "Nombre de la práctica",
      "settings.practiceName.hint": "Los recibos ya emitidos conservan el nombre con el que se emitieron. Si has registrado un perfil fiscal, tus recibos usan la razón social que consta allí.",
      "settings.practiceName.save": "Guardar nombre",
      "settings.practiceName.saved": "Nombre guardado",
      "settings.practiceName.tooShort": "El nombre de la práctica necesita al menos 2 caracteres.",
      "settings.practiceName.tooLong": "El nombre de la práctica no puede superar los 120 caracteres.",
      "settings.email": "Correo profesional",
      "settings.phone": "Teléfono (opcional)",
      "settings.shopEnabled": "Tienda activa (visible públicamente)",
      "settings.yes": "Sí",
      "settings.no": "No",
      "settings.bookingTermsFr": "Condiciones de reserva (FR)",
      "settings.bookingTermsEn": "Condiciones de reserva (EN)",
      "avail.error": "Error",
      "bookings.title": "Citas",
      "bookings.subtitle": "Las reservas realizadas por tus clientes.",
      "bookings.all": "Todas",
      "bookings.pending": "Pendientes",
      "bookings.confirmed": "Confirmadas",
      "bookings.cancelled": "Canceladas",
      "bookings.empty": "No hay citas en esta categoría.",
      "bookings.slot": "Horario",
      "bookings.client": "Cliente",
      "bookings.roomCreated": "Sala creada — URL copiada y enviada",
      "bookings.statusUpdated": "Estado actualizado",
      "bookings.timeTaken": "Su horario ha sido reservado por otra persona mientras tanto: esta cita no se puede restablecer.",
      "bookings.statusError": "Error al actualizar el estado",
      "bookings.startVideo": "Iniciar consulta por video",
      "bookings.confirm": "Confirmar",
      "bookings.cancel": "Cancelar",
      "bookings.statusLabel.pending": "Pendiente",
      "bookings.statusLabel.confirmed": "Confirmado",
      "bookings.statusLabel.cancelled": "Cancelado",
      "bookings.statusLabel.pending_payment": "Pago pendiente",
      "bookings.statusLabel.paid_needs_attention": "Pagada — requiere acción",
      "bookings.statusLabel.completed": "Finalizada",
      "bookings.pendingPayment": "Pago pendiente",
      "bookings.paidNeedsAttention": "Pagada — requiere acción",
      "bookings.awaitingPayment": "Esperando el pago",
      "bookings.expiresIn": "expira en {min} min",
      "bookings.expired": "expirado",
      "bookings.paidWarnTitle": "¿Cancelar esta cita pagada?",
      "bookings.paidWarnBody": "El cliente pagó {amount}. Cancelar NO lo reembolsa — el reembolso sigue siendo una acción separada, disponible justo después.",
      "bookings.paidWarnDismiss": "Volver",
      "bookings.paidWarnConfirm": "Cancelar de todos modos",
      "bookings.refundFollowupTitle": "Cita cancelada",
      "bookings.refundFollowupBody": "¿Reembolsar los {amount} cobrados ahora?",
      "bookings.refundLater": "Más tarde",
      "bookings.refundNow": "Reembolsar ahora",
      "bookings.refundSuccess": "Reembolso realizado",
      "bookings.refundError": "Error al reembolsar",
      "bookings.needsAttentionTitle": "Pagada, pero sin plaza disponible",
      "bookings.needsAttentionBody": "El pago llegó después de que expirara la reserva de plaza, y su horario fue reservado por otra persona mientras tanto. El dinero está cobrado: conserva la cita (solo es posible si su horario vuelve a estar libre) o reembolsa y cancela.",
      "bookings.keepAppointment": "Conservar la cita",
      "bookings.refundAndCancel": "Reembolsar y cancelar",
      "cal.title": "Calendario",
      "cal.subtitle": "Tus citas sobre tus horas de apertura. Arrastra una cita para moverla.",
      "cal.today": "Hoy",
      "cal.month": "Mes",
      "cal.week": "Semana",
      "cal.day": "Día",
      "cal.apptRescheduled": "Cita movida al {time}",
      "cal.loadError": "Error de carga",
      "gcal.title": "Google Calendar",
      "gcal.desc": "Sincroniza tus citas en ambos sentidos con tu Google Calendar.",
      "gcal.connect": "Conectar Google Calendar",
      "gcal.connected": "Conectado",
      "gcal.connectedAs": "Conectado como",
      "gcal.disconnect": "Desconectar",
      "gcal.syncNow": "Sincronizar ahora",
      "gcal.syncing": "Sincronizando…",
      "gcal.lastSync": "Última sync",
      "gcal.never": "Nunca",
      "gcal.syncDone": "Sincronizado: {pushed} citas enviadas, {busy} eventos importados",
      "gcal.syncPartial": "Sincronización incompleta: {pushed} enviadas, {failed} fallos — tu calendario de Google puede estar incompleto",
      "cal.detailDialogDesc": "Detalles de la cita",
      "ovr.dialogDesc": "Añadir un periodo de cierre",
      "gcal.connectedToast": "Google Calendar conectado con éxito",
      "gcal.errorToast": "Error al conectar Google Calendar",
      "gcal.scopeMissing": "Conexión rechazada: no se concedió el permiso de Calendario. Vuelve a conectar y marca el acceso a Google Calendar.",
      "gcal.disconnected": "Google Calendar desconectado",
      "gcal.notConfigured": "Google Calendar no está configurado en la plataforma.",
      "gcal.busyLegend": "Eventos de Google (ocupado)",
      "cal.updated": "Actualizado",
      "cal.video": "Video",
      "cal.confirmDetachCancel": "Cancelar",
      "cal.confirmOverrideTitle": "¿Mover de todos modos?",
      "cal.confirmOverrideOutsideBody": "Esta hora está fuera de tus horas de apertura publicadas (horario semanal, horas adicionales o cierre). Puedes mover la cita de todos modos: tendrá lugar fuera de tu horario publicado.",
      "cal.confirmOverrideBusyBody": "Un evento externo de Google ya ocupa ese horario. Puedes mover la cita de todos modos: tendrás dos compromisos a la vez.",
      "cal.confirmOverrideCancel": "Cancelar",
      "cal.confirmOverrideConfirm": "Mover de todos modos",
      "err.gcalNotConnected": "Google Calendar no está conectado",
      "err.invalidWindows": "Algunos horarios son inválidos o se superponen",
      "err.invalidTimezone": "Zona horaria inválida",
      "err.invalidRange": "Rango de fechas inválido",
      "err.templateNotFound": "Aún no se encontró un horario semanal",
      "err.tenantSuspended": "Cuenta suspendida: puedes consultar, pero los cambios están bloqueados. Actualiza la facturación para reactivar.",
      "err.outsideAvailability": "Esa hora está fuera de tu disponibilidad publicada.",
      "err.targetGcalBusy": "Un evento externo de Google ya ocupa esa franja.",
      "err.paymentPending": "Esta cita está esperando el pago — esta acción está bloqueada hasta que se liquide (cancelar o esperar sigue siendo posible).",
      "err.consultCharged": "Esta consulta ya se ha cobrado, así que no se puede cancelar. Para devolver el dinero, emite un reembolso desde Pagos.",
      "gate.title": "Conecta Google Calendar para publicar",
      "gate.body": "Publicar tu horario semanal requiere un Google Calendar conectado, para que los horarios ofrecidos tengan en cuenta tu agenda y evites reservas duplicadas.",
      "gcal.disconnectWarnTitle": "¿Desconectar Google Calendar?",
      "gcal.disconnectWarnBody": "{n} citas próximas están sincronizadas con Google Calendar. Desconectar detendrá su sincronización — permanecerán en Solunary pero ya no se reflejarán en Google.",
      "gcal.disconnectWarnBodyNone": "No hay citas próximas sincronizadas. Puedes desconectar Google Calendar sin problema.",
      "sync.busyChecked": "Ocupación de Google verificada {time}",
      "sync.busyCheckedNever": "Aún no verificado",
      "sync.mismatchPill": "{n} reservas para revisar",
      "sync.mismatchHelp": "Estas citas ya no coinciden con tu Google Calendar: el evento se movió o se eliminó en Google. Abre el calendario para revisarlas.",
      "sync.checkNow": "Verificar ahora",
      "sync.checking": "Verificando…",
      "sync.reconcileToast": "{cancelled} cancelada(s) · {drifted} movida(s)",
      "sync.noneLeft": "No quedan reservas para revisar",
      "sync.driftBanner": "Esta cita se movió en Google Calendar.",
      "sync.driftGoogleTime": "Google Calendar: {time}",
      "sync.driftSolunaryTime": "Solunary: {time}",
      "sync.repush": "Reenviar a Google",
      "sync.repushDone": "Reenviado a Google Calendar",
      "sync.acknowledge": "Confirmar",
      "sync.ackDone": "Confirmado",
      "sync.googleCancelledBanner": "Esta cita fue cancelada desde Google Calendar. La clienta no ha sido notificada.",
      "ovr.title": "Fechas bloqueadas",
      "ovr.subtitle": "Días en los que no estás disponible, incluso durante tu horario habitual.",
      "ovr.add": "Bloquear una fecha",
      "ovr.empty": "Aún no hay fechas bloqueadas.",
      "ovr.dateFrom": "Desde",
      "ovr.dateFromRequired": "La fecha de inicio es obligatoria",
      "ovr.dateTo": "Hasta (opcional)",
      "ovr.dateToHint": "Déjalo vacío para bloquear un solo día",
      "ovr.reason": "Motivo (opcional)",
      "ovr.reasonPlaceholder": "ej. Vacaciones, día libre…",
      "ovr.create": "Bloquear fechas",
      "ovr.created": "Fechas bloqueadas",
      "ovr.confirmDelete": "¿Eliminar esta fecha bloqueada?",
      "ovr.deleted": "Fecha bloqueada eliminada",
      "ovr.conflicts": "{count} reserva(s) existente(s) caen dentro de este rango",
      "ovr.dialogTitle": "Bloquear fechas",
      "sched.pageTitle": "Ajustes de disponibilidad",
      "sched.pageSubtitle": "Define tus horas de apertura y los servicios que ofrecen: tus clientes eligen un servicio y luego un horario.",
      "sched.viewCalendarLink": "Ver calendario",
      "sched.settingsTitle": "Horario semanal",
      "sched.timezone": "Zona horaria",
      "sched.statusDraft": "Borrador",
      "sched.statusPublished": "Publicado",
      "sched.save": "Guardar",
      "sched.saved": "Horario guardado",
      "sched.publish": "Publicar",
      "sched.published": "Horario publicado",
      "sched.publishNeedsConnect": "Conecta Google Calendar para publicar tu horario",
      "sched.publishNeedsSave": "Guarda tus cambios antes de publicar",
      "sched.dirty": "Cambios sin guardar",
      "sched.loadError": "No se pudo cargar tu horario",
      "sched.windowOverlap": "Algunos horarios se superponen",
      "sched.windowInvalid": "La hora de fin debe ser posterior a la de inicio",
      "sched.addWindow": "Añadir un horario",
      "sched.dayClosed": "Cerrado",
      "msg.title": "Mensajes",
      "msg.subtitle": "Tus conversaciones con tus clientes.",
      "msg.empty": "Aún no hay conversaciones.",
      "msg.selectToRead": "Selecciona una conversación para leerla.",
      "msg.noMessagesYet": "No hay mensajes en esta conversación.",
      "msg.loadOlder": "Mostrar mensajes anteriores",
      "msg.reply": "Tu respuesta",
      "msg.replyPlaceholder": "Escribe tu respuesta…",
      "msg.send": "Enviar",
      "msg.sending": "Enviando…",
      "msg.you": "Tú",
      "msg.client": "Cliente",
      "msg.charCount": "{n}/{max}",
      "msg.unread": "No leído",
      "msg.unreadOne": "1 mensaje no leído",
      "msg.unreadMany": "{n} mensajes no leídos",
      "testi.title": "Testimonios",
      "testi.subtitle": "Añade las reseñas de clientes que aparecen en tu sitio.",
      "testi.new": "Nuevo",
      "testi.empty": "Aún no hay testimonios personalizados. Los testimonios predeterminados siguen apareciendo en el sitio.",
      "testi.active": "Activo",
      "testi.hidden": "Oculto",
      "testi.order": "Orden",
      "testi.confirmDelete": "¿Eliminar el testimonio de {name}?",
      "testi.newTitle": "Nuevo testimonio",
      "testi.editTitle": "Editar",
      "testi.field.name": "Nombre",
      "testi.field.link": "Enlace (Google Maps)",
      "testi.field.quoteFr": "Cita (FR)",
      "testi.field.quoteEn": "Cita (EN)",
      "testi.field.charCount": "{count} / {max} caracteres",
      "testi.field.status": "Estado",
      "blog.title": "Artículos del diario",
      "blog.subtitle": "Crea, edita y publica tus artículos.",
      "blog.new": "Nuevo artículo",
      "blog.empty": "Aún no hay artículos.",
      "blog.published": "Publicado",
      "blog.draft": "Borrador",
      "blog.untitled": "Sin título",
      "blog.confirmDelete": "¿Eliminar «{title}»?",
      "blog.saveError": "Error al guardar",
      "blog.editTitle": "Editar",
      "blog.newTitle": "Nuevo artículo",
      "blog.field.titleFr": "Título (FR)",
      "blog.field.tagFr": "Etiqueta (FR)",
      "blog.field.excerptFr": "Extracto (FR)",
      "blog.field.bodyFr": "Contenido (FR)",
      "blog.field.titleEn": "Title (EN)",
      "blog.field.tagEn": "Tag (EN)",
      "blog.field.excerptEn": "Excerpt (EN)",
      "blog.field.bodyEn": "Body (EN)",
      "blog.field.slug": "Slug",
      "blog.field.cover": "Imagen de portada",
      "blog.field.status": "Estado",
      "blog.upload": "Subir",
      "branding.subtitle": "Personaliza la identidad visual de tu sitio público.",
      "branding.saved": "Marca guardada",
      "branding.imageUploaded": "Imagen subida",
      "branding.urlError": "URL no recuperada",
      "branding.uploadError": "Error de subida",
      "branding.identity": "Identidad",
      "branding.tagline": "Eslogan (bajo el título principal)",
      "branding.taglinePlaceholder": "Un viaje hacia el bienestar natural",
      "branding.specialties": "Especialidades (visibles en el marketplace Solunary)",
      "content.title": "Contenido del sitio",
      "content.subtitle": "Edita el texto de tu página de inicio, sección por sección, en el orden en que lo leen tus visitantes. Un campo vacío muestra el texto de ejemplo, salvo que su nota indique otra cosa.",
      "content.confirmDelete": "¿Eliminar la personalización «{key}»?",
      "content.addCustom": "Añadir una clave personalizada",
      "content.addCustomHint": "Opcional · Configuración avanzada, solo si necesitas anular una clave específica de tu plantilla.",
      "content.create": "Crear",
      "content.customPrefix": "Personalizado",
      "content.frPlaceholder": "Texto FR (vacío = predeterminado)",
      "content.enPlaceholder": "Texto EN (vacío = predeterminado)",
      "content.preset.hero.eyebrow": "Hero · Insignia sobre el título",
      "content.preset.hero.script": "Hero · Frase manuscrita",
      "content.preset.hero.sub": "Hero · Subtítulo",
      "content.preset.story.eyebrow": "Mi recorrido · Etiqueta sobre el título",
      "content.preset.story.title": "Mi recorrido · Título",
      "content.preset.story.lead": "Mi recorrido · Intro",
      "content.preset.approach.eyebrow": "Enfoque · Etiqueta sobre el título",
      "content.preset.approach.title": "Enfoque · Título",
      "content.preset.approach.lead": "Enfoque · Intro",
      "content.preset.services.lead": "Servicios · Intro",
      "content.preset.contact.lead": "Contacto · Intro",
      "content.preset.contact.email": "Contacto · Email",
      "content.preset.contact.place": "Contacto · Lugar",
      "content.section.hero": "Sección Hero",
      "content.section.story": "Sección Mi recorrido",
      "content.section.approach": "Sección Enfoque",
      "content.section.services": "Sección Servicios",
      "content.section.contact": "Sección Contacto",
      "nav.overview": "Resumen",
      "nav.siteBuilder": "Crear mi sitio",
      "nav.learn": "Cursos",
      "nav.telehealth": "Telesalud",
      "nav.blog": "Artículos",
      "nav.testimonials": "Testimonios",
      "nav.messages": "Mensajes",
      "nav.availability": "Disponibilidad",
      "nav.bookings": "Citas",
      "nav.calendar": "Calendario",
      "nav.customers": "Mis Clientes",
      "nav.quizReviews": "Revisión quiz",
      "nav.learnAnalytics": "Análisis Learn",
      "nav.payments": "Pagos",
      "nav.taxConfig": "Impuestos",
      "learn.title": "Solunary Learn",
      "learn.newCourse": "Nuevo curso",
      "learn.editCourse": "Editar curso",
      "learn.addLesson": "Lección",
      "learn.addQuiz": "Quiz",
      "learn.published": "Publicado",
      "learn.publishBtn": "Publicar",
      "learn.unpublishBtn": "Despublicar",
      "learn.draft": "Borrador",
      "learn.price": "Precio",
      "learn.currency": "Moneda",
      "learn.free": "Gratis",
      "learn.mandatory": "Obligatorio",
      "learn.lesson": "Lección",
      "learn.quiz": "Quiz",
      "learn.markComplete": "Marcar como completada",
      "learn.completed": "Lección completada",
      "learn.locked": "Lección bloqueada",
      "learn.lockedDesc": "Complete la lección obligatoria anterior para desbloquear esta.",
      "learn.quizSubmit": "Enviar quiz",
      "learn.quizRetry": "Reiniciar quiz",
      "learn.quizPassed": "¡Quiz aprobado!",
      "learn.quizFailed": "Puntuación insuficiente",
      "learn.answerAll": "Responda todas las preguntas para enviar.",
      "learn.openAnswerHint": "Respuesta libre — será revisada por el profesional",
      "learn.openAnswerPlaceholder": "Su respuesta…",
      "learn.enrollPrice": "Comprar y acceder",
      "learn.enrollFree": "Comenzar curso",
      "learn.emailPlaceholder": "su.correo@example.com",
      "learn.coursesWord": "cursos",
      "learn.sellHint": "Crea y vende tus formaciones.",
      "learn.fieldTitle": "Título *",
      "learn.fieldDescription": "Descripción",
      "learn.coverUrl": "Imagen de portada (URL)",
      "learn.freeHint": "0 = gratis",
      "learn.pricePlaceholder": "0.00 = gratis",
      "learn.publishLabel": "Publicar el curso (visible públicamente y en el marketplace Solunary)",
      "learn.lessonsWord": "Lecciones",
      "learn.noLessons": "Sin lecciones. Añade una Lección (contenido video/texto) o un Quiz.",
      "learn.publishNeedsLesson": "Añade al menos una lección para publicar este curso.",
      "learn.lastLessonPublished": "Un curso publicado necesita al menos una lección: despublícalo primero.",
      "learn.publishedEmptyWarning": "Publicado sin lecciones: nadie puede comprarlo. Añade una lección o despublícalo.",
      "learn.publishedToast": "Curso publicado.",
      "learn.unpublishedToast": "Curso despublicado.",
      "learn.coursesEmpty": "Tu trabajo 1:1 ya es material de curso. Deja que Solunary AI convierta tus protocolos en tu primera cohorte.",
      "learn.editBtn": "Editar",
      "learn.titlePlaceholderQuiz": "Título del quiz",
      "learn.titlePlaceholderLesson": "Título de la lección",
      "learn.mandatoryDescQuiz": "Obligatorio — bloquea las siguientes lecciones hasta aprobarla",
      "learn.mandatoryDescLesson": "Obligatorio — bloquea las siguientes lecciones hasta completarla",
      "learn.videoPlaceholder": "URL de video (YouTube embed, Vimeo, MP4 alojado)",
      "learn.lessonBodyPlaceholder": "Texto de la lección (opcional)",
      "learn.passThreshold": "Umbral de aprobación",
      "learn.durationLabel": "Duración",
      "learn.minutesSuffix": "min",
      "learn.qOpen": "abierta",
      "learn.qMcq": "Opción múltiple",
      "learn.questionPlaceholder": "Pregunta…",
      "learn.openAnswerDesc": "El estudiante responderá con texto libre. Acreditada automáticamente al enviar; puedes revisar las respuestas en la ficha del cliente.",
      "learn.markCorrect": "Marcar como respuesta correcta",
      "learn.choiceWord": "Opción",
      "learn.addChoice": "+ Añadir una opción",
      "learn.mcq": "Opción múltiple",
      "learn.longAnswer": "Respuesta larga",
      "learn.addQuestionHint": "Añade al menos una pregunta para este quiz.",
      "learn.titleRequired": "Título requerido",
      "learn.quizTitleRequired": "Ponle un título a este quiz antes de guardar.",
      "learn.saved": "Curso guardado",
      "learn.confirmDelete": "¿Eliminar este curso?",
      "learn.error": "Error",
      "promos.title": "Códigos promo",
      "promos.subtitle": "Crea códigos en porcentaje o monto fijo.",
      "promos.code": "Código",
      "promos.type": "Tipo",
      "promos.percentage": "Porcentaje (%)",
      "promos.fixed": "Monto fijo ($)",
      "promos.maxUses": "Usos máx (0 = ilimitado)",
      "promos.create": "Crear",
      "promos.empty": "Aún no hay códigos promo.",
      "promos.confirmDelete": "¿Eliminar?",
      "promos.discountPct": "{value}% de descuento",
      "promos.discountFixed": "{value} $ de descuento",
      "promos.uses": "usos",
      "promos.active": "activo",
      "promos.inactive": "inactivo",
      "gift.title": "Tarjetas regalo",
      "gift.subtitle": "Emite tarjetas manualmente o ve las vendidas en línea.",
      "gift.issueCard": "Emitir una tarjeta",
      "gift.value": "Valor (centavos, ej. 5000 = 50$)",
      "gift.recipientEmail": "Correo del destinatario",
      "gift.recipientName": "Nombre del destinatario",
      "gift.message": "Mensaje",
      "gift.issue": "Emitir",
      "gift.empty": "Aún no hay tarjetas regalo.",
      "gift.balance": "Saldo",
      "gift.soldOnline": "Vendida en línea",
      "gift.issuedManually": "Emitida manualmente",
      "gift.confirmCancel": "¿Cancelar esta tarjeta?",
      "gift.valueTooSmall": "Ingrese un valor de al menos {min} {currency}.",
      "shop.title": "Tienda",
      "shop.subtitle": "Productos Stripe y enlaces de afiliados.",
      "shop.activePublic": "Tienda activa públicamente",
      "shop.new": "Nuevo",
      "shop.empty": "Aún no hay productos.",
      "shop.active": "Activo",
      "shop.inactive": "Inactivo",
      "shop.affiliate": "Afiliado",
      "shop.externalLink": "Enlace externo",
      "shop.confirmDelete": "¿Eliminar?",
      "shop.newProduct": "Nuevo producto",
      "shop.edit": "Editar",
      "shop.nameFr": "Nombre (FR)",
      "shop.nameEn": "Name (EN)",
      "shop.descFr": "Description (FR)",
      "shop.descEn": "Description (EN)",
      "shop.type": "Tipo",
      "shop.typeStripe": "Stripe (venta directa)",
      "shop.typeAffiliate": "Enlace de afiliado (ej. Amazon)",
      "shop.productType": "Naturaleza del producto",
      "shop.productTypePhysical": "Físico (enviado)",
      "shop.productTypeDigital": "Digital (descarga o acceso)",
      "shop.price": "Precio ($)",
      "shop.affiliateUrl": "URL de afiliado",
      "shop.image": "Imagen",
      "shop.upload": "Subir",
      "shop.order": "Orden",
      "shop.cancel": "Cancelar",
      "shop.save": "Guardar",
      "tele.title": "Teleconsulta",
      "tele.subtitle": "Sus consultas de video: su sala y todas las consultas que ha realizado.",
      "tele.empty": "Aún no hay consultas — aparecerán aquí en cuanto un cliente reserve.",
      "tele.videoProvider": "Proveedor de videoconferencia",
      "tele.videoProviderNote": "Todas sus salas de consulta se abren con este proveedor. Solunary se encarga de ello: no tiene nada que configurar.",
      "mod.title": "Modalidades de cuidado",
      "mod.subtitle": "Elige tu modalidad: formularios de admisión, taxonomía y protocolos adaptados. La modalidad activa limita al asistente IA Solunary a su ámbito.",
      "mod.error": "Error",
      "mod.added": "Modalidad agregada",
      "mod.activated": "Modalidad activada — la IA ahora está limitada a este ámbito",
      "mod.confirmRemove": "¿Quitar esta modalidad?",
      "mod.myModalities": "Mis modalidades",
      "mod.active": "Activa",
      "mod.activate": "Activar",
      "mod.intake": "Admisión ({count} campos)",
      "mod.protocols": "Protocolos",
      "mod.steps": "pasos",
      "mod.catalog": "Catálogo de modalidades",
      "mod.add": "Agregar",
      "mod.allAdded": "Todas las modalidades están agregadas.",
      "ai.title": "Asistente IA",
      "ai.subtitle": "Impulsado por Claude Sonnet 4.5. Redacta, resume, idea — en segundos.",
      "ai.task.write_article": "Redactar un artículo",
      "ai.task.draft_reply": "Redactar una respuesta",
      "ai.task.summarize_messages": "Resumir mensajes",
      "ai.task.free_form": "Pregunta libre",
      "ai.ph.write_article": "Tema del artículo (ej: beneficios del ayuno intermitente)",
      "ai.ph.draft_reply": "Pega aquí el mensaje a responder...",
      "ai.ph.summarize_messages": "Pega varios mensajes, te haré un resumen accionable.",
      "ai.ph.free_form": "Lo que quieras...",
      "ai.promptRequired": "Escribe un prompt",
      "ai.error": "Error IA",
      "ai.copied": "¡Copiado!",
      "ai.yourInput": "Tu entrada",
      "ai.generate": "Generar",
      "ai.response": "Respuesta IA",
      "ai.copy": "Copiar",
      "insights.title": "Solunary Insights",
      "insights.subtitle": "Briefing IA diario",
      "insights.refresh": "Actualizar",
      "insights.generating": "Generando briefing...",
      "insights.draft": "Borrador IA — verifica antes de actuar",
      "insights.bookingsUpcoming": "Citas próximas",
      "insights.currentLeads": "Leads por seguir",
      "insights.scheduledPosts": "Posts programados",
      "insights.automationRuns": "Autom. (7d)",
      "insights.cachedToday": "En caché hoy",
      "insights.justNow": "Generado ahora",
      "insights.poweredBy": "Impulsado por Claude Sonnet 4.5",
      "lan.title": "Analytics Solunary Learn",
      "lan.subtitle": "Resumen del rendimiento de tus cursos.",
      "lan.courses": "Cursos",
      "lan.published": "{count} publicados",
      "lan.students": "Estudiantes",
      "lan.enrollments": "Inscripciones",
      "lan.revenue": "Ingresos",
      "lan.paidCourses": "Cursos de pago",
      "lan.perCourse": "Rendimiento por curso",
      "lan.empty": "Sin cursos. Crea tu primer curso en Solunary Learn.",
      "lan.colCourse": "Curso",
      "lan.colStatus": "Estado",
      "lan.colStudents": "Estudiantes",
      "lan.colCompleted": "Completados",
      "lan.colProgress": "Progreso prom.",
      "lan.colQuiz": "Punt. quiz prom.",
      "lan.colRevenue": "Ingresos",
      "lan.statusPublished": "Publicado",
      "lan.statusDraft": "Borrador",
      "tax.loadError": "Error de carga",
      "tax.presetApplied": "Preajuste aplicado — no olvides guardar",
      "tax.saved": "Configuración fiscal guardada ✓",
      "tax.error": "Error",
      "tax.title": "Configuración fiscal",
      "tax.subtitle": "Define los impuestos aplicados a tus cursos, productos y consultas. Se muestran en cada factura.",
      "tax.lines": "Líneas de impuesto",
      "tax.add": "Agregar",
      "tax.presets": "Preajustes comunes",
      "tax.empty": "Sin impuestos configurados. Tus clientes pagan el precio mostrado sin recargo.",
      "tax.namePh": "Nombre (IVA, GST…)",
      "tax.ratePh": "Tasa %",
      "tax.regPh": "N° de registro (opcional)",
      "tax.inclusive": "Los precios mostrados en mi sitio ya incluyen impuestos (con IVA)",
      "tax.save": "Guardar",
      "tax.previewTitle": "Vista previa en un curso de 100,00 $",
      "tax.subtotal": "Precio sin impuestos (subtotal)",
      "tax.totalCharged": "Total cobrado al cliente",
      "tax.commission": "Comisión Solunary ({pct}%)",
      "tax.net": "Neto para ti",
      "pay.error": "Error",
      "pay.paypalConnected": "PayPal conectado ✓",
      "pay.confirmDisconnect": "¿Desconectar {name}?",
      "pay.disconnected": "Desconectado",
      "pay.title": "Pagos",
      "pay.subtitle": "Conecta tu cuenta Stripe para recibir tus pagos — Solunary cobra los pagos de tus clientes y te transfiere tu parte.",
      "pay.paypal.desc": "Tus clientes pagan con PayPal, tarjeta o Pay in 4. Red internacional.",
      "pay.blockedBySolunary": "Desactivado por Solunary",
      "pay.connected": "Conectado",
      "pay.merchant": "Comerciante:",
      "pay.environment": "Entorno:",
      "pay.unavailableShort": "No disponible",
      "pay.disconnect": "Desconectar",
      "pay.docs": "Docs",
      "pay.howItWorks": "Cómo funciona:",
      "pay.howItWorksText": " Cuando un cliente paga un curso, producto o consulta, Solunary cobra el pago. Tu parte (el total menos la comisión de plataforma) se te transfiere después a tu cuenta Stripe conectada — la franja “Adeudado por Solunary / Pagado hasta la fecha” de abajo sigue esos importes.",
      "dom.copied": "Copiado",
      "dom.hostName": "Host / Nombre",
      "dom.valueTarget": "Valor / Destino",
      "dom.copyValue": "Copiar valor",
      "dom.error": "Error",
      "dom.enterDomain": "Ingresa un dominio",
      "dom.saved": "Dominio guardado — configura el DNS y verifica",
      "dom.title": "Dominio personalizado",
      "dom.subtitle": "Usa tu propia dirección (ej. www.miclinica.com) para tu sitio Solunary.",
      "dom.yourDomain": "Tu dominio",
      "dom.domain": "Dominio",
      "dom.save": "Guardar",
      "dom.dnsSteps": "Pasos de configuración DNS",
      "dom.step1": "Inicia sesión en tu registrador (OVH, GoDaddy, Cloudflare…).",
      "dom.step2": "Agrega los dos registros de abajo.",
      "dom.verify": "Verificar",
      "dom.lastCheck": "Última verif.:",
      "auto.ruleSaved": "Regla guardada",
      "auto.error": "Error",
      "auto.confirmDelete": "¿Eliminar esta regla?",
      "auto.deleted": "Eliminada",
      "auto.title": "Automation",
      "auto.subtitle": "{rules} reglas · {runs} ejecuciones recientes",
      "auto.newRule": "Nueva regla",
      "auto.tabRules": "Reglas",
      "auto.tabHistory": "Historial",
      "auto.empty": "Sin reglas. Haz clic en « Nueva regla » para automatizar tus flujos.",
      "auto.trigger": "Trigger:",
      "auto.disable": "Desactivar",
      "auto.enable": "Activar",
      "auto.edit": "Editar",
      "auto.runsCount": "Ejecutada {count} veces",
      "auto.lastRun": "última:",
      "auto.modalTitleEdit": "Editar regla",
      "auto.modalTitleNew": "Nueva regla",
      "auto.name": "Nombre",
      "auto.triggerLabel": "Trigger (evento)",
      "auto.actionsLabel": "Acciones (ejecutadas en orden)",
      "auto.addAction": "Agregar una acción",
      "auto.active": "Activa",
      "auto.save": "Guardar",
      "auto.cancel": "Cancelar",
      "auto.colDate": "Fecha",
      "auto.colRule": "Regla",
      "auto.colTrigger": "Trigger",
      "auto.colResults": "Resultados",
      "auto.noRuns": "Sin ejecuciones.",
      "social.demoAccount": "Cuenta demo creada",
      "social.oauthError": "Error OAuth",
      "social.confirmDisconnect": "¿Desconectar esta cuenta?",
      "social.accountDisconnected": "Cuenta desconectada",
      "social.publishedOn": "Publicado en {ok}/{total} cuenta(s){demo}",
      "social.demoSuffix": " (modo demo)",
      "social.publishError": "Error de publicación",
      "social.postSaved": "Publicación guardada",
      "social.error": "Error",
      "social.confirmDeletePost": "¿Eliminar esta publicación?",
      "social.topicRequired": "Indica un tema",
      "social.draftGenerated": "Borrador generado — valida antes de usar",
      "social.aiError": "Error IA",
      "social.draftApproved": "Borrador aprobado e insertado",
      "social.describeImage": "Describe la imagen",
      "social.imageGenerated": "Imagen generada",
      "social.title": "Social Media",
      "social.subtitle": "{total} publicaciones · {scheduled} programadas · {drafts} borradores",
      "social.all": "Todos",
      "social.newPost": "Nueva publicación",
      "social.connectedAccounts": "Cuentas conectadas ({count})",
      "social.demo": "(demo)",
      "social.noAccounts": "Sin cuentas conectadas. Haz clic en una plataforma arriba para empezar.",
      "social.demoParen": "(demo)",
      "social.platforms": "Plataformas",
      "social.genWithAi": "Generar con IA",
      "social.topicPh": "Tema de la publicación (ej: beneficios del jengibre en otoño)",
      "social.genText": "Generar el texto",
      "social.noTextWithoutValidation": "Ningún texto llega a un cliente sin validación",
      "social.approveUse": "Aprobar y usar",
      "social.reject": "Rechazar",
      "social.imageOptional": "Imagen (opcional)",
      "social.imagePh": "Describe la imagen (ej: infusión humeante en una taza de cerámica)",
      "social.genImage": "Generar la imagen",
      "social.modalEditPost": "Editar publicación",
      "social.modalNewPost": "Nueva publicación",
      "social.content": "Contenido",
      "social.status": "Estado",
      "social.scheduledDate": "Fecha programada",
      "social.save": "Guardar",
      "social.cancel": "Cancelar",
      "social.edit": "Editar",
      "social.publish": "Publicar",
      "social.emptyPosts": "Sin publicaciones todavía.",
      "bill.error": "Error",
      "bill.demoPortal": "Stripe en modo demo — portal no disponible. Usa « Cambiar de plan » abajo.",
      "bill.stripeError": "Error de Stripe",
      "bill.planUpdated": "Plan actualizado",
      "bill.title": "Suscripción y facturación",
      "bill.subtitle": "Gestiona tu plan, tu moneda y tus pagos.",
      "bill.changePlan": "Cambiar de plan",
      "bill.stripePortal": "Portal Stripe",
      "bill.demoTitle": "Modo demo Stripe",
      "bill.demoText": " — los cambios de plan se aplican de inmediato sin pago real. Para pasar a producción, configura una clave Stripe real.",
      "bill.currentPlan": "Plan actual",
      "bill.cycle.perMonth": "por mes",
      "bill.customPrice.label": "Precio negociado",
      "bill.customPrice.chip": "Precio negociado",
      "bill.customPrice.until": "hasta el {date}",
      "bill.cycle.perYear": "por año",
      "bill.customPrice.planChangeEnds": "Cambiar de plan pone fin a su precio negociado de {price}. El nuevo plan se factura a su precio habitual.",
      "bill.customPrice.endedByPlanChange": "Plan actualizado. Su precio negociado ya no se aplica.",
      "bill.err.billingChangeInProgress": "Ya se está aplicando un cambio de facturación a su suscripción. Inténtelo de nuevo en unos minutos.",
      "bill.err.practiceDeletionPending": "Esta consulta se está eliminando: no se puede abrir ninguna compra para ella.",
      "bill.activatedOn": "Activado el",
      "bill.currency": "Moneda",
      "bill.stripeCustomer": "Stripe Customer",
      "bill.from": "Desde {price}",
      "bill.activeAddons": "Add-ons de pago activos",
      "bill.services.title": "Solunary Services",
      "bill.services.subtitle": "Servicios done-for-you para acelerar tu práctica. Expresa tu interés — nuestro equipo te contactará.",
      "bill.services.thanks": "¡Gracias! El equipo Solunary te contactará.",
      "bill.services.interestSent": "Interés enviado",
      "bill.services.contactUs": "Contáctanos",
      "bill.services.pulse.desc": "Auditoría y salud de la cuenta mensual, recomendaciones priorizadas.",
      "bill.services.grow.desc": "Acompañamiento growth: funnels, contenido, campañas.",
      "bill.services.studio.desc": "Producción creativa: diseño, video, cursos llave en mano.",
      "bill.services.concierge.desc": "Gestión operativa delegada de tu práctica.",
      "bill.services.executive.desc": "Alianza estratégica dedicada, nivel dirección.",
      "bill.boosterActivated": "¡Booster activado!",
      "bill.purchaseConfirmed": "¡Compra confirmada!",
      "bill.purchaseCancelled": "Compra cancelada",
      "bill.confirmCancelBooster": "¿Desactivar el booster « {name} »?",
      "bill.boosterDeactivated": "Booster desactivado",
      "bill.boosters": "Boosters",
      "bill.boostersSub": "Add-ons recurrentes para ampliar tu plan (facturados mensualmente).",
      "bill.deactivate": "Desactivar",
      "bill.subscribe": "Suscribirse",
      "bill.active": "Activo",
      "bill.packages": "Paquetes e instalación",
      "bill.packagesSub": "Servicios llave en mano, pago único.",
      "bill.porting": "Migración de datos (Porting)",
      "bill.portingSub": "Importa tus datos desde tu herramienta anterior.",
      "bill.startingAt": "desde ",
      "bill.owned": "Adquirido",
      "bill.buy": "Comprar",
      "bill.recentTx": "Transacciones recientes",
      "bill.noTx": "Sin transacciones.",
      "bill.colDate": "Fecha",
      "bill.colType": "Tipo",
      "bill.colAmount": "Monto",
      "bill.colStatus": "Estado",
      "bill.txSubscription": "suscripción",
      "bill.changePlanTitle": "Cambiar de plan",
      "bill.changePlanSub": "Elige tu nuevo plan. Los cambios son prorrateados.",
      "bill.planActive": "Plan activo",
      "bill.upgradeTo": "Pasar a este plan",
      "bill.downgrade": "Bajar de plan",
      "bill.consolidated": "Factura consolidada",
      "bill.fourStreams": "Los 4 flujos Solunary · una sola factura",
      "bill.subscriptionLabel": "Suscripción — {name}",
      "bill.annualBilling": "Facturación anual (2 meses gratis)",
      "bill.monthlyBilling": "Facturación mensual",
      "bill.addons": "Add-ons",
      "bill.none": "Ninguno",
      "bill.platformFees": "Comisiones de plataforma cobradas",
      "bill.platformFeesSub": "Solunary Pay / Course Pay (a título indicativo)",
      "bill.solunaryServices": "Servicios Solunary",
      "bill.interestsCount": "{count} interés(es)",
      "bill.oneTimeRecent": "Compras puntuales (recientes)",
      "bill.recurringTotal": "Total recurrente",
      "bill.perYear": "/año",
      "bill.perMonth": "/mes",
      "login.title": "Panel de control",
      "login.subtitle": "Inicia sesión para gestionar tu sitio.",
      "login.error": "Error de inicio de sesión. Inténtalo de nuevo.",
      "login.continueGoogle": "Continuar con Google",
      "login.restricted": "Acceso restringido — solo la administradora del sitio.",
      "coming.title": "Módulos próximos",
      "coming.subtitle": "La hoja de ruta pública. Vota por los que te parezcan más útiles — priorizamos por uso.",
      "coming.voteToast": "¡Voto registrado para « {title} » — gracias!",
      "coming.vote": "Votar por este módulo",
      "coming.alreadyVoted": "Ya has votado — ¡gracias!",
      "coming.voteError": "No se pudo registrar tu voto. Inténtalo de nuevo.",
      "coming.shipped": "Ya disponible",
      "coming.ideaTitle": "¿Una idea de módulo que falta?",
      "coming.ideaText": "Solunary está hecho con y para los profesionales. Si algo te frena a diario, queremos saberlo.",
      "coming.suggest": "Proponer una idea",
      "coming.calsync.title": "Sincronización de calendario bidireccional",
      "coming.calsync.cat": "Calendario",
      "coming.calsync.desc": "Sincronización con Google Calendar y Microsoft/Outlook: tus citas y disponibilidad en tiempo real.",
      "coming.social.title": "Inicios de sesión sociales",
      "coming.social.cat": "Autenticación",
      "coming.social.desc": "Registro/inicio de sesión vía Google, Facebook y LinkedIn para ti y tus clientes.",
      "coming.multi.title": "Multi-profesional avanzado",
      "coming.multi.cat": "Equipo y roles",
      "coming.multi.desc": "Roles detallados (admin, profesional, recepción), permisos por módulo, registro de auditoría.",
      "coming.workflows.title": "Flujos visuales",
      "coming.workflows.cat": "Automation Pro",
      "coming.workflows.desc": "Constructor visual multietapa (estilo n8n) con ramas condicionales y retrasos.",
      "coming.emr.title": "Integraciones EMR/EHR",
      "coming.emr.cat": "Interoperabilidad sanitaria",
      "coming.emr.desc": "HL7 FHIR, Practice Better, Jane sync, exportaciones de cumplimiento HIPAA/PHIPA.",
      "qr.statusPending": "Por revisar",
      "qr.statusApproved": "Aprobado",
      "qr.statusRejected": "Rechazado",
      "qr.error": "Error",
      "qr.marked": "Marcado: {status}",
      "qr.title": "Revisión de cuestionarios",
      "qr.subtitle": "{pending} por revisar · {approved} aprobados · {rejected} rechazados",
      "qr.filterAll": "Todas",
      "qr.empty": "Sin respuestas largas por revisar.",
      "qr.mcqScore": "Puntuación MCQ: {score}% · {result}",
      "qr.passed": "aprobado",
      "qr.failed": "reprobado",
      "qr.lesson": "Lección:",
      "qr.student": "Estudiante:",
      "qr.approve": "Aprobar",
      "qr.reject": "Rechazar",
      "qr.question": "Pregunta",
      "qr.studentAnswer": "Respuesta del estudiante",
      "qr.noAnswer": "Sin respuesta",
      "sconn.active": "Activo",
      "sconn.toFinalize": "Por finalizar",
      "sconn.notConnected": "No conectado",
      "sconn.desc": "Recibe los pagos de tus ventas en tu cuenta Stripe. Solunary cobra cada venta y te transfiere tu parte tras un periodo de retención. La comisión de plataforma es de {fee}.",
      "sconn.descVaries": "Recibe los pagos de tus ventas en tu cuenta Stripe. Solunary cobra cada venta y te transfiere tu parte tras un periodo de retención. La comisión de plataforma depende del tipo de servicio:",
      "sconn.feeScopeNote": "Tu saldo disponible, el periodo de retención y el historial de pagos están en tu monedero, más abajo en esta página.",
      "sconn.svc.course": "Cursos",
      "sconn.svc.booking": "Citas",
      "sconn.svc.product": "Productos",
      "sconn.svc.program": "Programas",
      "sconn.svc.invoice": "Facturas",
      "sconn.svc.telehealth": "Teleconsultas",
      "sconn.blocked.no_account": "Su cuenta de Stripe aún no está conectada.",
      "sconn.blocked.payouts_disabled": "Stripe ha suspendido sus transferencias.",
      "sconn.blocked.transfers_inactive": "Stripe aún no ha habilitado su cuenta para recibir fondos.",
      "sconn.blocked.requirements_past_due": "Hay documentos vencidos: Stripe retiene sus transferencias hasta recibirlos.",
      "sconn.reqTitle": "Stripe todavía necesita:",
      "sconn.reqDisabledReason": "Motivo indicado por Stripe:",
      "sconn.req.external_account": "Los datos de su cuenta bancaria",
      "sconn.req.individual.verification.document": "Un documento de identidad",
      "sconn.req.individual.id_number": "Su número de identificación",
      "sconn.req.business_profile.url": "La dirección de su sitio web",
      "sconn.req.business_profile.mcc": "Su sector de actividad",
      "sconn.account": "Cuenta:",
      "sconn.payments": "Pagos:",
      "sconn.payouts": "Transferencias:",
      "sconn.demoNote": "Modo demo — Stripe Connect no está configurado en la plataforma.",
      "sconn.blockedNote": "Este método de pago ha sido desactivado por la administración de Solunary.",
      "sconn.manage": "Gestionar mi cuenta",
      "sconn.finalize": "Finalizar onboarding",
      "sconn.connect": "Conectar Stripe",
      "sconn.docs": "Docs",
      "sconn.returnToast": "Vuelta de Stripe — actualizando estado…",
      "sconn.error": "Error",
      "sconn.unavailable": "Stripe Connect no disponible",
      "brand.preview": "Vista previa",
      "brand.myClinic": "Mi consultorio",
      "brand.taglineHere": "Eslogan aquí",
      "brand.book": "Reservar",
      "brand.viewFullSite": "Ver el sitio completo →",
      "brand.palette": "Paleta",
      "brand.presetDefault": "Solunary (predeterminado)",
      "brand.colorPrimary": "Primario (oscuro)",
      "brand.colorAccent": "Acento (cálido)",
      "brand.colorSecondary": "Secundario",
      "brand.images": "Imágenes",
      "brand.logoLabel": "Logo (cuadrado, ≥256×256px)",
      "brand.heroLabel": "Imagen hero (horizontal, ≥1600×900px)",
      "brand.remove": "Quitar",
      "brand.clickUpload": "Haz clic para subir",
      "brand.orPasteUrl": "o pega una URL",
      "brand.specialtyPlaceholder": "+ Especialidad (Enter para confirmar)",
      "brand.add": "Agregar",
      "brand.suggestions": "Sugerencias",
      "brand.social": "Redes sociales",
      "brand.socialHint": "Estos enlaces aparecen en el pie de página de tu sitio público. Deja vacías las redes que no uses: no se mostrará ningún icono.",
      "brand.certificateTitle": "Certificados de finalización",
      "brand.certificateSubtitle": "Personaliza el logotipo y el estilo de diseño de tus certificados de finalización.",
      "brand.certificateLogoLabel": "Logotipo personalizado del certificado",
      "brand.certificateLogoHint": "Déjalo vacío para usar tu logo de marca principal automáticamente.",
      "brand.certificateStyleLabel": "Estilo de diseño",
      "brand.certificatePreviewBtn": "Vista previa del certificado (PDF)",
      "brand.certificateStyle.classic": "Salvia Solunary (Clásico)",
      "brand.certificateStyle.classicDesc": "Borde ceremonial verde salvia con medallón de sello dorado oficial",
      "brand.certificateStyle.modern": "Pizarra Moderna",
      "brand.certificateStyle.modernDesc": "Columna lateral arquitectónica en pizarra con tipografía alineada a la izquierda y línea de acento",
      "brand.certificateStyle.luxe": "Oro Elegante (Lujo)",
      "brand.certificateStyle.luxeDesc": "Tarjeta flotante sobre paspartú marfil con esquinas biseladas en oro y rombos ornamentales",
      "brand.certificateStyle.academic": "Diploma Académico",
      "brand.certificateStyle.academicDesc": "Encabezado institucional universitario con pedestales gemelos de firma y sello oficial",
      "brand.certificateStyle.minimal": "Minimalista Limpio",
      "brand.certificateStyle.minimalDesc": "Cuadrícula tipográfica suiza con marcas de registro y matriz de metadatos en 3 columnas",
      "brand.certificateStyleCurrent": "Estilo actual: {style}",
      "brand.certificateCustomizeLink": "Personalizar el logotipo y estilo en Marca →",
      "nav.products": "Tienda",
      "nav.programs": "Programas",
      "nav.promos": "Códigos promocionales",
      "nav.giftcards": "Tarjetas de regalo",
      "nav.invoices": "Facturas",
      "nav.crm": "CRM",
      "nav.ai": "Asistente IA",
      "nav.automation": "Automatización",
      "nav.social": "Redes sociales",
      "nav.branding": "Marca",
      "nav.customDomain": "Dominio personalizado",
      "nav.billing": "Suscripción",
      "nav.content": "Contenido del sitio",
      "nav.media": "Medios",
      "nav.siteImages": "Imágenes del sitio",
      "nav.settings": "Ajustes",
      "nav.comingSoon": "Próximamente",
      "section.addons": "Add-ons",
      "section.config": "Configuración",
      "section.roadmap": "Roadmap",
      "section.practice": "☀ Práctica",
      "section.academy": "☾ Academia",
      "section.intelligence": "✦ Inteligencia",
      "section.grow": "✦ Crecimiento",
      "nav.affiliate": "Afiliación",
      "nav.circle": "Circle",
      "section.site": "Sitio y Contenido",
      "nav.pathways": "Pathways",
      "nav.modalityPacks": "Modalidades",
      "banner.managingAs": "Estás gestionando {practice} como Super-Admin Solunary",
      "banner.return": "← Volver al Super-Admin",
      "accessDenied.title": "Acceso no autorizado",
      "accessDenied.body": "La cuenta {email} no está asociada a ningún espacio de profesional.",
      "accessDenied.hint": "Verifica que inicias sesión con la dirección de correo utilizada al registrar tu consultorio.",
      "accessDenied.switchAccount": "Cambiar de cuenta",
      "suspended.title": "Cuenta suspendida",
      "suspended.body": "El acceso al panel de este consultorio ha sido suspendido por Solunary.",
      "suspended.hint": "Contacta con el soporte de Solunary para restablecer el acceso.",
      "choosePractice.title": "¿Qué consulta?",
      "choosePractice.body": "Esta cuenta es propietaria de varias consultas. Elige la que quieres administrar: cierra sesión para cambiar a otra.",
      "noContext.title": "Ninguna consulta seleccionada",
      "noContext.body": "Has iniciado sesión como operador de la plataforma, pero esta página no indica ninguna consulta.",
      "noContext.hint": "Abre la consulta desde Super Admin → Consultas → Gestionar el admin.",
      "entryReserved.title": "Reservado a los Super-Admins",
      "entryReserved.body": "Tu cuenta del equipo Solunary ({email}) no puede abrir el panel de una consulta: está reservado a los Super-Admins.",
      "entryReserved.hint": "Pide a un Super-Admin si hace falta un cambio en esta consulta, o inicia sesión con la cuenta de tu propia consulta.",
      "login.errorSuspended": "Esta cuenta está suspendida: el inicio de sesión está bloqueado. Contacta con el soporte de Solunary para restablecer el acceso."
  },
};
